<template>
  <div>
    <vx-card class="relative">
      <div>
        <vs-row vs-w="12" class="mb-5">
          <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
            <vs-button @click="goBack" color="primary" type="border"
              >Back</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="4"
            vs-sm="4"
            vs-xs="12"
          >
            <h3>{{ campaignDescription.campaign_name }}</h3>
          </vs-col>

          <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
            <!-- <vs-button type="filled"
              @click="campaignDataOptions">Campaign Data Options</vs-button> -->
          </vs-col>

          <vs-col vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
        </vs-row>
      </div>
    </vx-card>
    <progress-bar
      bar-color="grey"
      :val="uploadPercentage"
      :text="PLeasewait"
    ></progress-bar>

    <vx-card class="vxtable">
     

      <vs-row vs-w="12" class="mb-5 pt-5">
        <vs-col vs-lg="10" vs-sm="10" vs-xs="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Company Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="company_name"
                v-model="accountDescription.company_name"
                v-validate="'required'"
                data-vv-as="Company Name"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('company_name')"
              >{{ errors.first('company_name') }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Registered Office Country:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <div
                :class="{
                  correction_field_input_class:
                    correction_fields_array.includes(
                      'registered_office_country'
                    )
                }"
              >
                <AccountAutocomplete
                  ref="accountEditRegisteredOfficeCountryRef"
                  :chosen="selected_registered_office_country"
                  class="searchbox"
                  :list="getCountries"
                  :searchOn="'registered_office_country'"
                >
                </AccountAutocomplete>
              </div>

              <!-- <vs-input
                class="w-full"
                v-model="accountDescription.registered_office_country"
              /> -->
            </div>
            <span
              v-if="registered_office_country_validation"
              class="text-danger text-sm mt-2 ml-16"
              >{{ registered_office_country_validation }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Company Registration Number:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="company_registration_number"
                v-model="accountDescription.company_registration_number"
                v-validate="{
                  required: !this.accountDescription.is_sole_trader
                }"
                data-vv-as="Company Registration Number"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('company_registration_number')"
              >{{ errors.first('company_registration_number') }}</span
            >
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Website URLs:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="website_url"
                v-validate="'url:require_protocol'"
                v-model="accounts.web"
                data-vv-as="website"
              />

              <template v-for="website in accountDescription.web">
                <span class="p-5">
                  <p>
                    {{ website.url }}
                    <vs-icon
                      class="ml-10 removeButton"
                      @click="removeSelectedWeb(website)"
                      color="success"
                      icon="clear"
                    ></vs-icon>
                  </p>
                </span>
              </template>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-button @click="addWebsite()" color="primary" type="filled"
                >Add</vs-button
              >
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('website_url')"
                >{{ errors.first('website_url') }}</span
              >
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Social Media Pages:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="linkedin"
                v-model="accounts.linkedin"
              />

              <template v-for="link in accountDescription.linkedin">
                <span class="p-5">
                  <p>
                    {{ link.url }}
                    <vs-icon
                      class="ml-10 removeButton"
                      @click="removeSelectedLinkedin(link)"
                      color="success"
                      icon="clear"
                    ></vs-icon>
                  </p>
                </span>
              </template>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-button
                color="primary"
                @click="addLinkedin"
                v-validate="'url:require_protocol'"
                type="filled"
                >Add</vs-button
              >
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('linkedin')"
                >{{ errors.first('linkedin') }}</span
              >
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Company Status:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="company_status"
                v-validate="'required'"
                v-model="accountDescription.status"
                data-vv-as="Company Status"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('company_status')"
              >{{ errors.first('company_status') }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Company Category:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="company_category"
                v-model="accountDescription.company_category"
                data-vv-as="Company Category"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('company_category')"
              >{{ errors.first('company_category') }}</span
            >
          </div>

          <!-- Registered Office -->
          <h5 class="mb-5">Registered Office Address</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 1:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="registered_office_address_1"
                v-model="accountDescription.registered_office_address_1"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 2:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                v-model="accountDescription.registered_office_address_2"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 3:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                v-model="accountDescription.registered_office_address_3"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>City:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                v-model="accountDescription.registered_office_city"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>County:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                v-model="accountDescription.registered_office_county"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Postcode:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                v-model="accountDescription.registered_office_postcode"
              />
            </div>
          </div>

          <!-- Head Office -->
          <h5 class="mb-5">Head Office Address</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span
                >Head Office Address is the Same As the Registered Office
                Address:</span
              >
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <!-- <input type="checkbox" v-model="headOfficeIsRegisteredOffice"/> -->
              <vs-switch
                vs-icon-on="check_box"
                vs-icon-off="block"
                v-model="headOfficeIsRegisteredOffice"
              >
                <span slot="on">YES</span>
                <span slot="off">NO</span>
              </vs-switch>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 1:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                v-model="accountDescription.head_office_address_1"
                name="head_office_address_1"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 2:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                v-model="accountDescription.head_office_address_2"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 3:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                v-model="accountDescription.head_office_address_3"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>City:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="head_office_city"
                v-model="accountDescription.head_office_city"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>County:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                v-model="accountDescription.head_office_county"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Postcode:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                v-model="accountDescription.head_office_postcode"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Country:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <div
                :class="{
                  correction_field_input_class:
                    correction_fields_array.includes('head_office_country')
                }"
              >
                <AccountAutocomplete
                  ref="accountEditHeadOfficeCountryRef"
                  :chosen="selected_head_office_country"
                  class="searchbox"
                  :list="getCountries"
                  :searchOn="'head_office_country'"
                >
                </AccountAutocomplete>
              </div>

              <!-- <vs-input
                class="w-full"
                v-model="accountDescription.head_office_country"
              /> -->
            </div>
            <span
              v-if="head_office_country_validation"
              class="text-danger text-sm mt-2 ml-16"
              >{{ head_office_country_validation }}</span
            >
          </div>
          <vs-divider class="m-5" />

          <!-- Site Office -->
          <h5 class="mb-5">Site Office Address</h5>
          <template v-for="(site, index) in accounts.satellite_office">
            <div>
              <vs-divider class="m-5" />
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Address Line 1:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input
                    class="w-full"
                    name="satellite_office_address_1"
                    data-vv-as="Address Line 1"
                    v-model="site.address_1"
                  />
                </div>
                <vs-icon
                  class="ml-10 removeButton"
                  @click="removeSelectedSiteAddress(site)"
                  color="success"
                  icon="clear"
                ></vs-icon>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Address Line 2:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.address_2" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Address Line 3:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.address_3" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>City:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.city" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>County:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.county" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Postcode:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.postcode" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Country:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <v-select
                    name="site_country"
                    class="site_country"
                    label="name_1"
                    :options="all_countries"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="site.country"
                  />
                  <!-- <vs-input class="w-full" v-model="site.country" /> -->
                </div>
              </div>

              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Telephone:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full" v-if="site.phone != null">
                  <div v-if="site.phone.length != 0">
                    <template v-for="(site_ph, ph_index) in site.phone">
                      <div
                        :key="ph_index"
                        v-if="site_ph.satellite_office_id == site.id"
                      >
                        <div class="vx-row">
                          <div class="vx-col sm:w-1/2 w-full">
                            <v-select
                              name="phone_code"
                              class="phone_code"
                              label="name_with_code"
                              :options="all_phone_codes"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'"
                              v-model="site_ph.phone_code"
                            />
                          </div>
                          <div class="vx-col sm:w-1/2 w-full">
                            <vs-input
                              @input="
                                site_ph.phone_no = site_ph.phone_no
                                  .replace(/[^0-9.]/g, '')
                                  .replace(/(\..*?)\..*/g, '$1')
                              "
                              class="w-full"
                              v-model="site_ph.phone_no"
                            />
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>

                  <div class="vx-col w-full" v-else>
                    <div class="vx-row">
                      <div class="vx-col sm:w-1/2 w-full">
                        <v-select
                          name="phone_code"
                          class="phone_code"
                          label="name_with_code"
                          :options="all_phone_codes"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          v-model="site.phone_code"
                        />
                      </div>
                      <div class="vx-col sm:w-1/2 w-full">
                        <vs-input
                          class="w-full"
                          @input="
                            site.phone_no = site.phone_no
                              .replace(/[^0-9.]/g, '')
                              .replace(/(\..*?)\..*/g, '$1')
                          "
                          v-model="site.phone_no"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="vx-col sm:w-1/3 w-full" v-else>
                  <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full">
                      <v-select
                        name="phone_code"
                        class="phone_code"
                        label="name_with_code"
                        :options="all_phone_codes"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="site.phone_code"
                      />
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                      <vs-input
                        class="w-full"
                        @input="
                          site.phone_no = site.phone_no
                            .replace(/[^0-9.]/g, '')
                            .replace(/(\..*?)\..*/g, '$1')
                        "
                        v-model="site.phone_no"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <vs-col
            class="mb-5"
            vs-offset="4"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="4"
          >
            <vs-button color="primary" @click="addSiteOffice()" type="filled"
              >Add Satellite Office</vs-button
            >
          </vs-col>

          <vs-divider class="m-5" />
          <!-- Telephone -->
          <div class="vx-row">
            <h6 class="p-5">Telephone Number(s)</h6>

            <div class="vx-col sm:w-1/3 w-full">
              <vs-button @click="addPhone()" color="primary" type="filled"
                >Add</vs-button
              >
            </div>
          </div>

          <template v-for="(w, index) in accountDescription.phone">
            <div class="flex mb-4">
              <div class="w-1/6 bg-grid-color-secondary h-12 mr-5">
                <v-select
                  :class="{
                    correction_field_input_class:
                      (correction_fields_array.includes(
                        'switchboard_phone_code'
                      ) &&
                        accountDescription.phone[index]['phone_type'] ==
                          'Head Office Switchboard') ||
                      (correction_fields_array.includes('phone_code') &&
                        accountDescription.phone[index]['phone_type'] !=
                          'Head Office Switchboard')
                  }"
                  name="phone_code"
                  class="phone_code"
                  label="name_with_code"
                  :options="all_phone_codes"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="accountDescription.phone[index]['phone_code']"
                />
              </div>

              <div class="w-1/5 bg-grid-color-secondary h-12 mr-5">
                <vs-input
                  class="w-full"
                  name="phone"
                  v-model="accountDescription.phone[index]['phone_no']"
                />
              </div>
              <div class="w-1/5 bg-grid-color-secondary h-12 mr-5">
                <v-select
                  label="name"
                  :options="accounts.phoneTypes"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="accountDescription.phone[index]['phone_type']"
                />
              </div>

              <div class="w-1/5 bg-grid-color h-12">
                <vs-icon
                  class="removeButton"
                  @click="removeSelectedPhone(w)"
                  color="success"
                  icon="clear"
                >
                </vs-icon>
              </div>
            </div>
          </template>

          <div class="vx-row">
            <h6 class="p-5">Sic Codes(s)</h6>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <AccountAutocomplete
                :class="{
                  correction_field_input_class:
                    correction_fields_array.includes('sic_code')
                }"
                ref="SicCodeRefEdit"
                class="searchbox"
                :chosen="selected_sic_code"
                :list="getSicCodes"
                :searchOn="'sic_codes'"
              ></AccountAutocomplete>
            </div>

            <div class="vx-col sm:w-1/3 w-full">
              <vs-button color="primary" @click="addSicCodes" type="filled"
                >Add</vs-button
              >
            </div>
          </div>
          <template v-for="sic in accounts.joinedSicAndDescription">
            <p class="m-10">
              {{ sic.name }}
              <vs-icon
                class="ml-10 removeButton"
                @click="removeNewSelectedSicCode(sic)"
                color="success"
                icon="clear"
              ></vs-icon>
            </p>
          </template>

          <vs-divider class="m-5" />
          <h5 class="mb-5">Other Details</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Registration Jurisdiction:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <div
                :class="{
                  correction_field_input_class:
                    correction_fields_array.includes(
                      'registration_jurisdiction'
                    )
                }"
              >
                <AccountAutocomplete
                  ref="EditAccountRegistrationJurisdictionRef"
                  :chosen="selected_registration_jurisdiction"
                  class="searchbox"
                  :list="getCountries"
                  :searchOn="'registration_jurisdiction'"
                >
                </AccountAutocomplete>
              </div>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Parent Company:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <div>
                <vs-row vs-w="12" class="mb-5">
                  <vs-col vs-lg="11" vs-sm="12" vs-xs="12">
                    <AccountAutocomplete
                      :class="{
                        correction_field_input_class:
                          correction_fields_array.includes('parent')
                      }"
                      ref="EditAccountParentRef"
                      :list="getParentCompany"
                      :searchOn="'parent'"
                    >
                    </AccountAutocomplete>
                  </vs-col>

                  <vs-col vs-lg="1" vs-sm="2" vs-xs="12">
                    <vs-icon
                      @click.stop="getSubsidiaryAccounts()"
                      size="small"
                      icon="check"
                      bg="#efd9d9"
                      style="cursor: pointer; margin-left: 15px"
                    ></vs-icon>
                  </vs-col>
                </vs-row>
              </div>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Vertical:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <div
                :class="{
                  correction_field_input_class:
                    correction_fields_array.includes('vertical')
                }"
              >
                <AccountAutocomplete
                  ref="EditAccountVerticalRef"
                  class="searchbox"
                  :chosen="selected_vertical"
                  :list="getVerticals"
                  :searchOn="'vertical'"
                ></AccountAutocomplete>
              </div>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Revenue:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/2 w-full">
                  <v-select
                    :class="{
                      correction_field_input_class:
                        correction_fields_array.includes('currency_code')
                    }"
                    label="label"
                    :options="currencyCodes"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="accountDescription.currency_code"
                  />
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-input
                    :class="{
                      correction_field_input_class:
                        correction_fields_array.includes('revenue')
                    }"
                    type="number"
                    class="w-full"
                    v-model="accountDescription.revenue"
                  />
                </div>
              </div>
              <span
                v-if="currency_code_validation"
                class="text-danger text-sm mt-2 ml-16"
                >{{ currency_code_validation }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>No. of Employees:</span>
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <vs-input
                :class="{
                  correction_field_input_class:
                    correction_fields_array.includes('no_of_employees')
                }"
                type="number"
                class="w-full"
                v-model="accountDescription.employees"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Notes:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-textarea class="w-full" v-model="accountDescription.notes" />
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button @click="submitForm()" class="mr-3 mb-2"
                >Submit</vs-button
              >
            </div>
          </div>
        </vs-col>

        <vs-col vs-lg="2" vs-sm="2" vs-xs="12">
          <div class="mt-5">
            <div>
              <u><h4>Satellite Office</h4></u>
            </div>

            <AccountAutocomplete
              class="searchbox2"
              :list="getParentCompany"
              @update_satellite_office_event="handleUpdateSatelliteOfficeEvent"
              :searchOn="'update_satellite_office'"
            >
            </AccountAutocomplete>
          </div>
          <div class="mb-5">
            <u><h4>Potential Matches</h4></u>
          </div>

          <div>
            <vs-list>
              <template v-for="(match, index) in potential_account_matches">
                <vs-list-item :key="index">
                  <p class="p-2">{{ match.company_name }}</p>
                  <p class="p-2">{{ match.registered_office_country }}</p>
                  <p class="p-2">
                    {{ match.company_registration_number
                    }}<vs-icon
                      @click.stop="viewPotentialMatchAccountDetails(match)"
                      size="small"
                      icon="info"
                      style="cursor: pointer; margin-left: 15px"
                    ></vs-icon>
                  </p>

                  <vs-divider class="m-5" />
                </vs-list-item>
              </template>
            </vs-list>
          </div>
        </vs-col>
      </vs-row>
    </vx-card>

    <template v-if="accountExists">
      <vs-popup
        fullscreen
        :title="accountDescription.company_name"
        :active.sync="popupActive"
      >
        <div class="flex justify-between flex-wrap">
          <vs-button class="mb-4 mr-6" @click="accept()" type="border"
            >Accept</vs-button
          >
          <vs-button
            class="mb-4"
            type="border"
            @click="reject()"
            color="primary"
            >Reject</vs-button
          >
        </div>
        <vs-list>
          <vs-list-header
            title="Key Company Details"
            color="success"
          ></vs-list-header>
          <vs-list-item title="Company Name ">
            {{ accountDescription.company_name }}
          </vs-list-item>
          <vs-list-item title="Company Registration Number">
            {{ accountDescription.company_registration_number }}
          </vs-list-item>
          <vs-list-item title="Switchboard">
            <template v-for="(ph, index) in accountDescription.phone">
              <div :key="index">
                <template v-for="(ph_type, index2) in ph.phone_type">
                  <div
                    :key="index2"
                    v-if="
                      ph_type.type == 'Switchboard' && ph_type.phone_id == ph.id
                    "
                  >
                    {{ ph.phone_no }}
                  </div>
                </template>
              </div>
            </template>
          </vs-list-item>
          <vs-list-item title="Site Switchboard">
            <template v-for="(ph, index) in accountDescription.phone">
              <div :key="index">
                <template v-for="(ph_type, index2) in ph.phone_type">
                  <div
                    :key="index2"
                    v-if="
                      ph_type.type == 'Site Switchboard' &&
                      ph_type.phone_id == ph.id
                    "
                  >
                    {{ ph.phone_no }}
                  </div>
                </template>
              </div>
            </template>
          </vs-list-item>
        </vs-list>

        <vs-list>
          <vs-list-header title="Address" color="success"></vs-list-header>
          <vs-list-item title="Head Office Address">
            {{ accountDescription.head_office_address_1 }}
            {{ accountDescription.head_office_address_2 }}
            {{ accountDescription.head_office_address_3 }}
            {{ accountDescription.head_office_city }}
            {{ accountDescription.head_office_postcode }}
            {{ accountDescription.head_office_county }}
            {{ accountDescription.head_office_country }}
          </vs-list-item>
          <vs-list-item title="Registered Office Address">
            {{ accountDescription.registered_office_address_1 }}
            {{ accountDescription.registered_office_address_2 }}
            {{ accountDescription.registered_office_address_3 }}
            {{ accountDescription.registered_office_city }}
            {{ accountDescription.registered_office_postcode }}
            {{ accountDescription.registered_office_county }}
            {{ accountDescription.registered_office_country }}
          </vs-list-item>
          <template
            v-for="(satellite, index) in accountDescription.satellite_office"
          >
            <vs-list-item
              :title="'Satellite Office ' + (index + 1)"
              :key="index"
            >
              <template v-for="(phone, index3) in satellite.phone">
                <div
                  :key="index3"
                  v-if="phone.satellite_office_id == satellite.id"
                >
                  {{ phone.phone_no }}
                </div>
              </template>
              {{ satellite.address_1 }}
              {{ satellite.address_2 }}
              {{ satellite.address_3 }}
              {{ satellite.town }}
              {{ satellite.county }}
              {{ satellite.postcode }}

              <template v-for="(country, index2) in satellite.country">
                <div
                  :key="index2"
                  v-if="country.satellite_office_id == satellite.id"
                >
                  {{ country.name_1 }}
                  {{ country.name_2 }}
                  {{ country.name_3 }}
                </div>
              </template>
            </vs-list-item>
          </template>
        </vs-list>

        <vs-list>
          <vs-list-header title="Websites" color="success"></vs-list-header>
          <template v-for="(web, index) in accountDescription.web">
            <div :key="index">
              {{ web.url }}
            </div>
          </template>
        </vs-list>
        <vs-list>
          <vs-list-header title="LinkedIn" color="success"></vs-list-header>
          <template v-for="(linkedin, index) in accountDescription.linkedin">
            <div :key="index">
              {{ linkedin.url }}
            </div>
          </template>
        </vs-list>
      </vs-popup>
    </template>

    <div class="vx-col w-full mb-base" v-if="showUpdateSatelliteOfficePopup">
      <vs-popup
        fullscreen
        id="satelliteOfficePopup"
        :title="update_account_and_add_to_campaign_heading"
        :active.sync="updateSatelliteOfficePopupActive"
      >
        <form>
          <vx-card>
            <div class="vx-row mb-6">
              <vs-row
                vs-w="12"
                class="mb-5"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                <vs-col vs-lg="5" vs-sm="5" vs-xs="12">
                  <div class="text-h5 font-medium mb-4 float-right">
                    <u> Master Database </u>
                  </div>
                </vs-col>

                <vs-col vs-lg="2" vs-sm="2" vs-xs="12">
                  <div class="text-h5 font-medium mb-4 ml-20 float-left"></div>
                </vs-col>

                <vs-col vs-lg="3" vs-sm="3" vs-xs="12">
                  <div class="text-h5 font-medium mb-4 ml-14 float-left">
                    <u> Build Data </u>
                  </div>
                </vs-col>
                <!-- <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
            <div class="text-h5 font-medium mb-4">Build Data</div>
          </vs-col> -->
              </vs-row>

              <div class="vx-col sm:w-1/5 w-full">
                <span>Company Name:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  name="company_name"
                  v-model="updateSatelliteOfficeAccountDescription.company_name"
                  v-validate="'required'"
                  data-vv-as="Company Name"
                />
              </div>
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('company_name')"
                >{{ errors.first('company_name') }}</span
              >

              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{ accountDescription.company_name }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Company Registration Number:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  name="company_registration_number"
                  v-model="
                    updateSatelliteOfficeAccountDescription.company_registration_number
                  "
                  v-validate="{
                    required:
                      !this.updateSatelliteOfficeAccountDescription
                        .is_sole_trader
                  }"
                  data-vv-as="Company Registration Number"
                />
              </div>
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('company_registration_number')"
                >{{ errors.first('company_registration_number') }}</span
              >

              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{ accountDescription.company_registration_number }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Company Status:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  name="company_status"
                  v-validate="'required'"
                  v-model="updateSatelliteOfficeAccountDescription.status"
                  data-vv-as="Company Status"
                />
              </div>
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('company_status')"
                >{{ errors.first('company_status') }}</span
              >
              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{ accountDescription.status }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Company Category:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  name="company_category"
                  v-model="
                    updateSatelliteOfficeAccountDescription.company_category
                  "
                  data-vv-as="Company Category"
                />
              </div>
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('company_category')"
                >{{ errors.first('company_category') }}</span
              >

              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{ accountDescription.company_category }}
              </div>
            </div>
            <vs-divider class="m-5" />

            <!-- Registered Office -->
            <h5 class="mb-5">Registered Office Address</h5>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 1:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  name="registered_office_address_1"
                  v-model="
                    updateSatelliteOfficeAccountDescription.registered_office_address_1
                  "
                />
              </div>

              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-switch
                    vs-icon-on="check_box"
                    vs-icon-off="block"
                    v-model="
                      overwriteDataBuildRegisteredOfficeAddressToMasterDB
                    "
                  >
                    <span slot="on">YES</span>
                    <span slot="off">NO</span>
                  </vs-switch>
                </div>

                {{ accountDescription.registered_office_address_1 }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 2:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  v-model="
                    updateSatelliteOfficeAccountDescription.registered_office_address_2
                  "
                />
              </div>
              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{ accountDescription.registered_office_address_2 }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 3:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  v-model="
                    updateSatelliteOfficeAccountDescription.registered_office_address_3
                  "
                />
              </div>
              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{ accountDescription.registered_office_address_3 }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>City:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  v-model="
                    updateSatelliteOfficeAccountDescription.registered_office_city
                  "
                />
              </div>
              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{ accountDescription.registered_office_city }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>County:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  v-model="
                    updateSatelliteOfficeAccountDescription.registered_office_county
                  "
                />
              </div>
              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{ accountDescription.registered_office_county }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Postcode:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  v-model="
                    updateSatelliteOfficeAccountDescription.registered_office_postcode
                  "
                />
              </div>
              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{ accountDescription.registered_office_postcode }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Country:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <AccountAutocomplete
                  ref="SatelliteOfficeaccountEditRegisteredOfficeCountryRef"
                  :chosen="selected_registered_office_country"
                  class="searchbox"
                  :list="getCountries"
                  :searchOn="'registered_office_country'"
                >
                </AccountAutocomplete>

                <!-- <vs-input
                class="w-full"
                v-model="updateSatelliteOfficeAccountDescription.registered_office_country"
              /> -->
              </div>
              <span
                v-if="registered_office_country_validation"
                class="text-danger text-sm mt-2 ml-16"
                >{{ registered_office_country_validation }}</span
              >

              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{ accountDescription.registered_office_country }}
              </div>
            </div>
            <vs-divider class="m-5" />

            <!-- Head Office -->
            <h5 class="mb-5">Head Office Address</h5>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span
                  >Head Office Address is the Same As the Registered Office
                  Address:</span
                >
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-switch
                  vs-icon-on="check_box"
                  vs-icon-off="block"
                  v-model="satelliteOfficeheadOfficeIsRegisteredOffice"
                >
                  <span slot="on">YES</span>
                  <span slot="off">NO</span>
                </vs-switch>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 1:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  v-model="
                    updateSatelliteOfficeAccountDescription.head_office_address_1
                  "
                  name="head_office_address_1"
                />
              </div>

              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-switch
                    vs-icon-on="check_box"
                    vs-icon-off="block"
                    v-model="overwriteDataBuildHeadOfficeAddressToMasterDB"
                  >
                    <span slot="on">YES</span>
                    <span slot="off">NO</span>
                  </vs-switch>
                </div>

                {{ accountDescription.head_office_address_1 }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 2:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  v-model="
                    updateSatelliteOfficeAccountDescription.head_office_address_2
                  "
                />
              </div>
              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{ accountDescription.head_office_address_2 }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 3:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  v-model="
                    updateSatelliteOfficeAccountDescription.head_office_address_3
                  "
                />
              </div>
              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{ accountDescription.head_office_address_3 }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>City:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  name="head_office_city"
                  v-model="
                    updateSatelliteOfficeAccountDescription.head_office_city
                  "
                />
              </div>
              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{ accountDescription.head_office_city }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>County:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  v-model="
                    updateSatelliteOfficeAccountDescription.head_office_county
                  "
                />
              </div>
              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{ accountDescription.head_office_county }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Postcode:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  v-model="
                    updateSatelliteOfficeAccountDescription.head_office_postcode
                  "
                />
              </div>

              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{ accountDescription.head_office_postcode }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Country:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <AccountAutocomplete
                  ref="SatelliteOfficeaccountEditHeadOfficeCountryRef"
                  :chosen="selected_head_office_country"
                  class="searchbox"
                  :list="getCountries"
                  :searchOn="'head_office_country'"
                >
                </AccountAutocomplete>

                <!-- <vs-input
                class="w-full"
                v-model="updateSatelliteOfficeAccountDescription.head_office_country"
              /> -->
              </div>
              <span
                v-if="head_office_country_validation"
                class="text-danger text-sm mt-2 ml-16"
                >{{ head_office_country_validation }}</span
              >

              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{ accountDescription.head_office_country }}
              </div>
            </div>
            <vs-divider class="m-5" />
            <div class="vx-row">
              <h6 class="p-5">Website URLs</h6>
            </div>
            <template
              v-if="
                updateSatelliteOfficeAccountDescription.web &&
                updateSatelliteOfficeAccountDescription.web.length > 0
              "
            >
            </template>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <vs-input
                  class="w-full"
                  name="website_url"
                  v-validate="'url:require_protocol'"
                  v-model="SatelliteOfficeaccounts.web"
                  data-vv-as="website"
                />
              </div>

              <div class="vx-col sm:w-1/3 w-full">
                <vs-button
                  @click="SatelliteOfficeaddWebsite"
                  color="primary"
                  type="filled"
                  >Add</vs-button
                >

                <span
                  class="text-danger text-sm mt-2 ml-16"
                  v-show="errors.has('website_url')"
                  >{{ errors.first('website_url') }}</span
                >
              </div>

              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{ accountDescription.website }}
              </div>
            </div>

            <template
              v-for="website in updateSatelliteOfficeAccountDescription.web"
            >
              <span class="p-5">
                <p>
                  {{ website.url }}
                  <vs-icon
                    class="ml-10 removeButton"
                    @click="removeSatelliteOfficeSelectedWeb(website)"
                    color="success"
                    icon="clear"
                  ></vs-icon>
                </p>
              </span>
            </template>

            <vs-divider class="m-5" />
            <div class="vx-row">
              <h6 class="p-5">Social Media Pages</h6>
            </div>
            <template
              v-if="
                updateSatelliteOfficeAccountDescription.linkedin &&
                updateSatelliteOfficeAccountDescription.linkedin.length > 0
              "
            >
            </template>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <vs-input
                  class="w-full"
                  name="linkedin"
                  v-model="SatelliteOfficeaccounts.linkedin"
                />
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-button
                  color="primary"
                  @click="SatelliteOfficeaddLinkedin"
                  v-validate="'url:require_protocol'"
                  type="filled"
                  >Add</vs-button
                >
                <span
                  class="text-danger text-sm mt-2 ml-16"
                  v-show="errors.has('linkedin')"
                  >{{ errors.first('linkedin') }}</span
                >
              </div>

              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{ accountDescription.linkendin }}
              </div>
            </div>

            <template
              v-for="link in updateSatelliteOfficeAccountDescription.linkedin"
            >
              <span class="p-5">
                <p>
                  {{ link.url }}
                  <vs-icon
                    class="ml-10 removeButton"
                    @click="removeSatelliteOfficeSelectedLinkedin(link)"
                    color="success"
                    icon="clear"
                  ></vs-icon>
                </p>
              </span>
            </template>
            <vs-divider class="m-5" />

            <!-- Site Office -->
            <h5 class="mb-5">Site Office Address</h5>
            <template
              v-for="(
                site, index
              ) in updateSatelliteOfficeAccountDescription.satellite_office"
            >
              <div :key="index">
                <vs-divider class="m-5" />
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Address Line 1:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input
                      class="w-full"
                      name="satellite_office_address_1"
                      data-vv-as="Address Line 1"
                      v-model="site.address_1"
                    />
                  </div>
                  <vs-icon
                    class="ml-10 removeButton"
                    @click="SatelliteOfficeremoveSelectedSiteAddress(site)"
                    color="success"
                    icon="clear"
                  ></vs-icon>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Address Line 2:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input class="w-full" v-model="site.address_2" />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Address Line 3:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input class="w-full" v-model="site.address_3" />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>City:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input class="w-full" v-model="site.city" />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>County:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input class="w-full" v-model="site.county" />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Postcode:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input class="w-full" v-model="site.postcode" />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Country:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <v-select
                      name="site_country"
                      class="site_country"
                      label="name_1"
                      :options="all_countries"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="site.country"
                    />
                    <!-- <vs-input class="w-full" v-model="site.country" /> -->
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Telephone:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full" v-if="site.phone != null">
                    <div v-if="site.phone.length != 0">
                      <template v-for="(site_ph, ph_index) in site.phone">
                        <div
                          :key="ph_index"
                          v-if="site_ph.satellite_office_id == site.id"
                        >
                          <div class="vx-row">
                            <div class="vx-col sm:w-1/2 w-full">
                              <v-select
                                name="phone_code"
                                class="phone_code"
                                label="name_with_code"
                                :options="all_phone_codes"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                v-model="site_ph.phone_code"
                              />
                            </div>
                            <div class="vx-col sm:w-1/2 w-full">
                              <vs-input
                                @input="
                                  site_ph.phone_no = site_ph.phone_no
                                    .replace(/[^0-9.]/g, '')
                                    .replace(/(\..*?)\..*/g, '$1')
                                "
                                class="w-full"
                                v-model="site_ph.phone_no"
                              />
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>

                    <div class="vx-col w-full" v-else>
                      <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full">
                          <v-select
                            name="phone_code"
                            class="phone_code"
                            label="name_with_code"
                            :options="all_phone_codes"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                            v-model="site.phone_code"
                          />
                        </div>
                        <div class="vx-col sm:w-1/2 w-full">
                          <vs-input
                            class="w-full"
                            @input="
                              site.phone_no = site.phone_no
                                .replace(/[^0-9.]/g, '')
                                .replace(/(\..*?)\..*/g, '$1')
                            "
                            v-model="site.phone_no"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="vx-col sm:w-1/3 w-full" v-else>
                    <div class="vx-row">
                      <div class="vx-col sm:w-1/2 w-full">
                        <v-select
                          name="phone_code"
                          class="phone_code"
                          label="name_with_code"
                          :options="all_phone_codes"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          v-model="site.phone_code"
                        />
                      </div>
                      <div class="vx-col sm:w-1/2 w-full">
                        <vs-input
                          class="w-full"
                          @input="
                            site.phone_no = site.phone_no
                              .replace(/[^0-9.]/g, '')
                              .replace(/(\..*?)\..*/g, '$1')
                          "
                          v-model="site.phone_no"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <vs-col
              class="mb-5"
              vs-offset="4"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="4"
            >
              <vs-button
                color="primary"
                @click="SatelliteOfficeaddSiteOffice"
                type="filled"
                >Add Satellite Office</vs-button
              >
            </vs-col>

            <vs-divider class="m-5" />
            <!-- Telephone -->
            <div class="vx-row">
              <h6 class="p-5">Telephone Number(s)</h6>

              <div class="vx-col sm:w-1/2 w-full">
                <vs-button
                  @click="addSatelliteOfficePhone()"
                  color="primary"
                  type="filled"
                  >Add</vs-button
                >
              </div>

              <div
                class="vx-col p-5 ml-14"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                <div v-if="accountDescription.switchboard != null">
                  {{ accountDescription.switchboard_phone_code }}
                  {{ accountDescription.switchboard }}
                  <span class="ml-5">{{ 'Head Office Switchboard' }}</span>
                  <br />
                </div>

                {{ accountDescription.phone_code }}
                {{ accountDescription.phone_no }}
                <span class="ml-5">{{ accountDescription.phone_type }}</span>
              </div>
            </div>

            <template
              v-for="(
                w, index
              ) in updateSatelliteOfficeAccountDescription.phone"
            >
              <div class="flex mb-4">
                <div class="w-1/6 bg-grid-color-secondary h-12 mr-5">
                  <v-select
                    name="phone_code"
                    class="phone_code"
                    label="name_with_code"
                    :options="all_phone_codes"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="
                      updateSatelliteOfficeAccountDescription.phone[index][
                        'phone_code'
                      ]
                    "
                  />
                </div>

                <div class="w-1/7 bg-grid-color-secondary h-12 mr-5">
                  <vs-input
                    class="w-full"
                    name="phone"
                    v-model="
                      updateSatelliteOfficeAccountDescription.phone[index][
                        'phone_no'
                      ]
                    "
                  />
                </div>

                <div class="w-1/6 bg-grid-color-secondary h-12 mr-5">
                  <v-select
                    label="name"
                    :options="accounts.phoneTypes"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="
                      updateSatelliteOfficeAccountDescription.phone[index][
                        'phone_type'
                      ]
                    "
                  />
                </div>

                <div class="w-1/5 bg-grid-color h-12">
                  <vs-icon
                    class="removeButton"
                    @click="removeSatelliteOfficeSelectedPhone(w)"
                    color="success"
                    icon="clear"
                  >
                  </vs-icon>
                </div>
              </div>
            </template>

            <!-- Sic Code -->
            <div class="vx-row">
              <h6 class="p-5">Sic Codes(s)</h6>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <AccountAutocomplete
                  ref="SatelliteOfficeSicCodeRefEdit"
                  class="searchbox"
                  :chosen="selected_sic_code"
                  :list="getSicCodes"
                  :searchOn="'sic_codes'"
                ></AccountAutocomplete>
                <!-- <vs-input
                type="number"
                class="w-full"
                v-model="SatelliteOfficeaccounts.sic_code"
              /> -->
              </div>

              <div class="vx-col sm:w-1/3 w-full">
                <vs-button
                  color="primary"
                  @click="SatelliteOfficeaddSicCodes"
                  type="filled"
                  >Add</vs-button
                >
              </div>

              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{ accountDescription.sic_code }}
              </div>
            </div>
            <template
              v-for="sic in SatelliteOfficeaccounts.joinedSicAndDescription"
            >
              <p class="m-10">
                {{ sic.name }}
                <vs-icon
                  class="ml-10 removeButton"
                  @click="removeSatelliteNewSelectedSicCode(sic)"
                  color="success"
                  icon="clear"
                ></vs-icon>
              </p>
            </template>

            <vs-divider class="m-5" />
            <h5 class="mb-5">Other Details</h5>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Registration Jurisdiction:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <AccountAutocomplete
                  ref="SatelliteOfficeEditAccountRegistrationJurisdictionRef"
                  :chosen="selected_registration_jurisdiction"
                  class="searchbox"
                  :list="getCountries"
                  :searchOn="'registration_jurisdiction'"
                >
                </AccountAutocomplete>
              </div>

              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{
                  this.$refs.EditAccountRegistrationJurisdictionRef.$refs
                    .suggestComponent.input.value
                }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Parent Company:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <AccountAutocomplete
                  ref="SatelliteOfficeEditAccountParentRef"
                  class="searchbox"
                  :list="getParentCompany"
                  :searchOn="'parent'"
                >
                </AccountAutocomplete>
              </div>

              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{
                  this.$refs.EditAccountParentRef.$refs.suggestComponent.input
                    .value
                }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Vertical:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <AccountAutocomplete
                  ref="SatelliteOfficeEditAccountVerticalRef"
                  class="searchbox"
                  :chosen="selected_vertical"
                  :list="getVerticals"
                  :searchOn="'vertical'"
                ></AccountAutocomplete>
              </div>

              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{
                  this.$refs.EditAccountVerticalRef.$refs.suggestComponent.input
                    .value
                }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Revenue:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/2 w-full">
                    <v-select
                      label="label"
                      :options="currencyCodes"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="
                        updateSatelliteOfficeAccountDescription.currency_code
                      "
                    />
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      type="number"
                      class="w-full"
                      v-model="updateSatelliteOfficeAccountDescription.revenue"
                    />
                  </div>
                </div>
                <span
                  v-if="satellite_office_currency_code_validation"
                  class="text-danger text-sm mt-2 ml-16"
                  >{{ satellite_office_currency_code_validation }}</span
                >
              </div>
              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{ accountDescription.currency_code }}
                {{ accountDescription.revenue }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>No. of Employees:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  type="number"
                  class="w-full"
                  v-model="
                    updateSatelliteOfficeAccountDescription.no_of_employees
                  "
                />
              </div>

              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{ accountDescription.employees }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Notes:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-textarea
                  class="w-full"
                  v-model="updateSatelliteOfficeAccountDescription.notes"
                />
              </div>

              <div
                class="vx-col ml-20"
                v-if="
                  update_account_and_add_to_campaign_heading ==
                  'Matched Account Details'
                "
              >
                {{ accountDescription.notes }}
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full"></div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-button
                  class="mr-3 mb-2"
                  @click.prevent="updateSatelliteOfficeForm"
                  >Update</vs-button
                >

                <vs-button
                  class="mr-3 mb-2"
                  @click.prevent="cancelSatelliteOfficeForm"
                  >Cancel</vs-button
                >
              </div>
            </div>
          </vx-card>
        </form>
      </vs-popup>
    </div>

  <div v-if="subsidiaryPopupActive">
      <vs-popup
        fullscreen
        id="subsidiaryPopup"
        title="Add Parent Account"
        :active.sync="subsidiaryPopupActive"
        :button-close-hidden="true"
        @close="closeShowSchedulePopup"
      >
        <form>
          <vx-card>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Company Name:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  name="company_name"
                  v-model="subsidiaryAccountDescription.company_name"
                  v-validate="'required'"
                  data-vv-as="Company Name"
                />
              </div>
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('company_name')"
                >{{ errors.first('company_name') }}</span
              >
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Company Registration Number:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  name="company_registration_number"
                  v-model="
                    subsidiaryAccountDescription.company_registration_number
                  "
                  v-validate="{
                    required:
                      !this.subsidiaryAccountDescription
                        .is_sole_trader
                  }"
                  data-vv-as="Company Registration Number"
                />
              </div>
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('company_registration_number')"
                >{{ errors.first('company_registration_number') }}</span
              >
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Company Status:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  name="company_status"
                  v-validate="'required'"
                  v-model="subsidiaryAccountDescription.status"
                  data-vv-as="Company Status"
                />
              </div>
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('company_status')"
                >{{ errors.first('company_status') }}</span
              >
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Company Category:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  name="company_category"
                  v-model="
                    subsidiaryAccountDescription.company_category
                  "
                  data-vv-as="Company Category"
                />
              </div>
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('company_category')"
                >{{ errors.first('company_category') }}</span
              >
            </div>
            <vs-divider class="m-5" />

            <!-- Registered Office -->
            <h5 class="mb-5">Registered Office Address</h5>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 1:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  name="registered_office_address_1"
                  v-model="
                    subsidiaryAccountDescription.registered_office_address_1
                  "
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 2:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  v-model="
                    subsidiaryAccountDescription.registered_office_address_2
                  "
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 3:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  v-model="
                    subsidiaryAccountDescription.registered_office_address_3
                  "
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>City:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  v-model="
                    subsidiaryAccountDescription.registered_office_city
                  "
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>County:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  v-model="
                    subsidiaryAccountDescription.registered_office_county
                  "
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Postcode:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  v-model="
                    subsidiaryAccountDescription.registered_office_postcode
                  "
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Country:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <AccountAutocomplete
                  ref="subsidiaryaccountEditRegisteredOfficeCountryRef"
                  :chosen="selected_registered_office_country"
                  class="searchbox"
                  :list="getCountries"
                  :searchOn="'registered_office_country'"
                >
                </AccountAutocomplete>

                <!-- <vs-input
                class="w-full"
                v-model="subsidiaryAccountDescription.registered_office_country"
              /> -->
              </div>
              <span
                v-if="registered_office_country_validation"
                class="text-danger text-sm mt-2 ml-16"
                >{{ registered_office_country_validation }}</span
              >
            </div>
            <vs-divider class="m-5" />

            <!-- Head Office -->
            <h5 class="mb-5">Head Office Address</h5>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span
                  >Head Office Address is the Same As the Registered Office
                  Address:</span
                >
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <!-- <input type="checkbox" v-model="headOfficeIsRegisteredOffice"/> -->
                <vs-switch
                  vs-icon-on="check_box"
                  vs-icon-off="block"
                  v-model="subsidiaryheadOfficeIsRegisteredOffice"
                >
                  <span slot="on">YES</span>
                  <span slot="off">NO</span>
                </vs-switch>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 1:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  v-model="
                    subsidiaryAccountDescription.head_office_address_1
                  "
                  name="head_office_address_1"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 2:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  v-model="
                    subsidiaryAccountDescription.head_office_address_2
                  "
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 3:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  v-model="
                    subsidiaryAccountDescription.head_office_address_3
                  "
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>City:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  name="head_office_city"
                  v-model="
                    subsidiaryAccountDescription.head_office_city
                  "
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>County:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  v-model="
                    subsidiaryAccountDescription.head_office_county
                  "
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Postcode:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  v-model="
                    subsidiaryAccountDescription.head_office_postcode
                  "
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Country:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <AccountAutocomplete
                  ref="subsidiaryaccountEditHeadOfficeCountryRef"
                  :chosen="selected_head_office_country"
                  class="searchbox"
                  :list="getCountries"
                  :searchOn="'head_office_country'"
                >
                </AccountAutocomplete>

                <!-- <vs-input
                class="w-full"
                v-model="subsidiaryAccountDescription.head_office_country"
              /> -->
              </div>
              <span
                v-if="head_office_country_validation"
                class="text-danger text-sm mt-2 ml-16"
                >{{ head_office_country_validation }}</span
              >
            </div>
            <vs-divider class="m-5" />
            <div class="vx-row">
              <h6 class="p-5">Website URLs</h6>
            </div>
            <template
              v-if="
                subsidiaryAccountDescription.web &&
                subsidiaryAccountDescription.web.length > 0
              "
            >
            </template>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <vs-input
                  class="w-full"
                  name="website_url"
                  v-validate="'url:require_protocol'"
                  v-model="subsidiaryaccounts.web"
                  data-vv-as="website"
                />
              </div>

              <div class="vx-col sm:w-1/3 w-full">
                <vs-button
                  @click="subsidiaryaddWebsite"
                  color="primary"
                  type="filled"
                  >Add</vs-button
                >
                <span
                  class="text-danger text-sm mt-2 ml-16"
                  v-show="errors.has('website_url')"
                  >{{ errors.first('website_url') }}</span
                >
              </div>
            </div>

            <template
              v-for="website in subsidiaryAccountDescription.web"
            >
              <span class="p-5">
                <p>
                  {{ website.url }}
                  <vs-icon
                    class="ml-10 removeButton"
                    @click="removesubsidiarySelectedWeb(website)"
                    color="success"
                    icon="clear"
                  ></vs-icon>
                </p>
              </span>
            </template>

            <vs-divider class="m-5" />
            <div class="vx-row">
              <h6 class="p-5">Social Media Pages</h6>
            </div>
            <template
              v-if="
                subsidiaryAccountDescription.linkedin &&
                subsidiaryAccountDescription.linkedin.length > 0
              "
            >
            </template>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <vs-input
                  class="w-full"
                  name="linkedin"
                  v-model="subsidiaryaccounts.linkedin"
                />
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-button
                  color="primary"
                  @click="subsidiaryaddLinkedin"
                  v-validate="'url:require_protocol'"
                  type="filled"
                  >Add</vs-button
                >
                <span
                  class="text-danger text-sm mt-2 ml-16"
                  v-show="errors.has('linkedin')"
                  >{{ errors.first('linkedin') }}</span
                >
              </div>
            </div>

            <template
              v-for="link in subsidiaryAccountDescription.linkedin"
            >
              <span class="p-5">
                <p>
                  {{ link.url }}
                  <vs-icon
                    class="ml-10 removeButton"
                    @click="removesubsidiarySelectedLinkedin(link)"
                    color="success"
                    icon="clear"
                  ></vs-icon>
                </p>
              </span>
            </template>
            <vs-divider class="m-5" />

            <!-- Site Office -->
            <h5 class="mb-5">Site Office Address</h5>
            <template
              v-for="(
                site, index
              ) in subsidiaryAccountDescription.satellite_office"
            >
              <div :key="index">
                <vs-divider class="m-5" />
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Address Line 1:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input
                      class="w-full"
                      name="satellite_office_address_1"
                      data-vv-as="Address Line 1"
                      v-model="site.address_1"
                    />
                  </div>
                  <vs-icon
                    class="ml-10 removeButton"
                    @click="subsidiaryremoveSelectedSiteAddress(site)"
                    color="success"
                    icon="clear"
                  ></vs-icon>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Address Line 2:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input class="w-full" v-model="site.address_2" />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Address Line 3:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input class="w-full" v-model="site.address_3" />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>City:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input class="w-full" v-model="site.city" />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>County:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input class="w-full" v-model="site.county" />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Postcode:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input class="w-full" v-model="site.postcode" />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Country:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <v-select
                      name="site_country"
                      class="site_country"
                      label="name_1"
                      :options="all_countries"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="site.country"
                    />
                    <!-- <vs-input class="w-full" v-model="site.country" /> -->
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/5 w-full">
                    <span>Telephone:</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full" v-if="site.phone != null">
                    <div v-if="site.phone.length != 0">
                      <template v-for="(site_ph, ph_index) in site.phone">
                        <div
                          :key="ph_index"
                          v-if="site_ph.satellite_office_id == site.id"
                        >
                          <div class="vx-row">
                            <div class="vx-col sm:w-1/2 w-full">
                              <v-select
                                name="phone_code"
                                class="phone_code"
                                label="name_with_code"
                                :options="all_phone_codes"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                v-model="site_ph.phone_code"
                              />
                            </div>
                            <div class="vx-col sm:w-1/2 w-full">
                              <vs-input
                                @input="
                                  site_ph.phone_no = site_ph.phone_no
                                    .replace(/[^0-9.]/g, '')
                                    .replace(/(\..*?)\..*/g, '$1')
                                "
                                class="w-full"
                                v-model="site_ph.phone_no"
                              />
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>

                    <div class="vx-col w-full" v-else>
                      <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full">
                          <v-select
                            name="phone_code"
                            class="phone_code"
                            label="name_with_code"
                            :options="all_phone_codes"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                            v-model="site.phone_code"
                          />
                        </div>
                        <div class="vx-col sm:w-1/2 w-full">
                          <vs-input
                            class="w-full"
                            @input="
                              site.phone_no = site.phone_no
                                .replace(/[^0-9.]/g, '')
                                .replace(/(\..*?)\..*/g, '$1')
                            "
                            v-model="site.phone_no"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="vx-col sm:w-1/3 w-full" v-else>
                    <div class="vx-row">
                      <div class="vx-col sm:w-1/2 w-full">
                        <v-select
                          name="phone_code"
                          class="phone_code"
                          label="name_with_code"
                          :options="all_phone_codes"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          v-model="site.phone_code"
                        />
                      </div>
                      <div class="vx-col sm:w-1/2 w-full">
                        <vs-input
                          class="w-full"
                          @input="
                            site.phone_no = site.phone_no
                              .replace(/[^0-9.]/g, '')
                              .replace(/(\..*?)\..*/g, '$1')
                          "
                          v-model="site.phone_no"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <vs-col
              class="mb-5"
              vs-offset="4"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="4"
            >
              <vs-button
                color="primary"
                @click="subsidiaryaddSiteOffice"
                type="filled"
                >Add Satellite Office</vs-button
              >
            </vs-col>

            <vs-divider class="m-5" />
            <!-- Telephone -->
            <div class="vx-row">
              <h6 class="p-5">Telephone Number(s)</h6>

              <div class="vx-col sm:w-1/2 w-full">
                <vs-button
                  @click="addsubsidiaryPhone()"
                  color="primary"
                  type="filled"
                  >Add</vs-button
                >
              </div>
            </div>

            <template
              v-for="(
                w, index
              ) in subsidiaryAccountDescription.phone"
            >
              <div class="flex mb-4">
                <div class="w-1/6 bg-grid-color-secondary h-12 mr-5">
                  <v-select
                    name="phone_code"
                    class="phone_code"
                    label="name_with_code"
                    :options="all_phone_codes"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="
                      subsidiaryAccountDescription.phone[index][
                        'phone_code'
                      ]
                    "
                  />
                </div>

                <div class="w-1/7 bg-grid-color-secondary h-12 mr-5">
                  <vs-input
                    class="w-full"
                    name="phone"
                    v-model="
                      subsidiaryAccountDescription.phone[index][
                        'phone_no'
                      ]
                    "
                  />
                </div>

                <div class="w-1/6 bg-grid-color-secondary h-12 mr-5">
                  <v-select
                    label="name"
                    :options="accounts.phoneTypes"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="
                      subsidiaryAccountDescription.phone[index][
                        'phone_type'
                      ]
                    "
                  />
                </div>

                <div class="w-1/5 bg-grid-color h-12">
                  <vs-icon
                    class="removeButton"
                    @click="removesubsidiarySelectedPhone(w)"
                    color="success"
                    icon="clear"
                  >
                  </vs-icon>
                </div>
              </div>
            </template>

            <!-- Sic Code -->
            <div class="vx-row">
              <h6 class="p-5">Sic Codes(s)</h6>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <AccountAutocomplete
                  ref="subsidiarySicCodeRefEdit"
                  class="searchbox"
                  :chosen="selected_sic_code"
                  :list="getSicCodes"
                  :searchOn="'sic_codes'"
                ></AccountAutocomplete>
                <!-- <vs-input
                type="number"
                class="w-full"
                v-model="subsidiaryaccounts.sic_code"
              /> -->
              </div>

              <div class="vx-col sm:w-1/3 w-full">
                <vs-button
                  color="primary"
                  @click="subsidiaryaddSicCodes"
                  type="filled"
                  >Add</vs-button
                >
              </div>
            </div>
            <template
              v-for="sic in subsidiaryaccounts.joinedSicAndDescription"
            >
              <p class="m-10">
                {{ sic.name }}
                <vs-icon
                  class="ml-10 removeButton"
                  @click="removeSatelliteNewSelectedSicCode(sic)"
                  color="success"
                  icon="clear"
                ></vs-icon>
              </p>
            </template>

            <vs-divider class="m-5" />
            <h5 class="mb-5">Other Details</h5>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Registration Jurisdiction:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <AccountAutocomplete
                  ref="subsidiaryEditAccountRegistrationJurisdictionRef"
                  :chosen="selected_registration_jurisdiction"
                  class="searchbox"
                  :list="getCountries"
                  :searchOn="'registration_jurisdiction'"
                >
                </AccountAutocomplete>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Parent Company:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <AccountAutocomplete
                  ref="subsidiaryEditAccountParentRef"
                  class="searchbox"
                  :list="getParentCompany"
                  :searchOn="'parent'"
                >
                </AccountAutocomplete>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Vertical:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <AccountAutocomplete
                  ref="subsidiaryEditAccountVerticalRef"
                  class="searchbox"
                  :chosen="selected_vertical"
                  :list="getVerticals"
                  :searchOn="'vertical'"
                ></AccountAutocomplete>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Revenue:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/2 w-full">
                    <v-select
                      label="label"
                      :options="currencyCodes"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="
                        subsidiaryAccountDescription.currency_code
                      "
                    />
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      type="number"
                      class="w-full"
                      v-model="subsidiaryAccountDescription.revenue"
                    />
                  </div>
                </div>
                <span
                  v-if="satellite_office_currency_code_validation"
                  class="text-danger text-sm mt-2 ml-16"
                  >{{ satellite_office_currency_code_validation }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>No. of Employees:</span>
              </div>
              <div class="vx-col sm:w-1/6 w-full">
                <vs-input
                  type="number"
                  class="w-full"
                  v-model="
                    subsidiaryAccountDescription.no_of_employees
                  "
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Notes:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-textarea
                  class="w-full"
                  v-model="subsidiaryAccountDescription.notes"
                />
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full"></div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-button
                  class="mr-3 mb-2"
                  @click.prevent="submitSubsidiaryForm"
                  >Add Parent To The Campaign</vs-button
                >

                <vs-button
                  class="mr-3 mb-2"
                  @click.prevent="cancelSubsidiaryForm"
                  >Close And Do Not Add To The Campaign</vs-button
                >
              </div>
            </div>
          </vx-card>
        </form>
      </vs-popup>
    </div>

    <vs-popup
      title="List of Accounts Matched By Website"
      :active.sync="MatchedWebsitePopupActive"
    >
      <div>
        <vs-list>
          <template v-for="(match, index) in matched_websites">
            <vs-list-item :key="index">
              <p class="p-2">{{ match.company_name }}</p>
              <p class="p-2">{{ match.registered_office_country }}</p>
              <p class="p-2">
                {{ match.company_registration_number
                }}<vs-icon
                  @click.stop="viewPotentialMatchAccountDetails(match)"
                  size="small"
                  icon="info"
                  style="cursor: pointer; margin-left: 15px"
                ></vs-icon>
              </p>
            </vs-list-item>
          </template>

          <div class="vx-row mt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button @click="AddWebsiteAnyWay()" class="mr-3 mb-2"
                >Submit</vs-button
              >

              <vs-button @click="CancelWebsitePopup()" class="mr-3 mb-2"
                >Cancel</vs-button
              >
            </div>
          </div>
        </vs-list>
      </div>
    </vs-popup>

    <vs-popup
      title="List of Accounts Matched By LinkedIn"
      :active.sync="MatchedLinkedInPopupActive"
    >
      <div>
        <vs-list>
          <template v-for="(match, index) in matched_linkedins">
            <vs-list-item :key="index">
              <p class="p-2">{{ match.company_name }}</p>
              <p class="p-2">{{ match.registered_office_country }}</p>
              <p class="p-2">
                {{ match.company_registration_number
                }}<vs-icon
                  @click.stop="viewPotentialMatchAccountDetails(match)"
                  size="small"
                  icon="info"
                  style="cursor: pointer; margin-left: 15px"
                ></vs-icon>
              </p>
            </vs-list-item>
          </template>

          <div class="vx-row mt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button @click="AddLinkedInAnyWay()" class="mr-3 mb-2"
                >Submit</vs-button
              >

              <vs-button @click="CancelLinkedInPopup()" class="mr-3 mb-2"
                >Cancel</vs-button
              >
            </div>
          </div>
        </vs-list>
      </div>
    </vs-popup>

    <vs-popup title="Account already matches other accounts in master database" :active.sync="MatchedAccountsPopupActive">
      <div>
        <vs-list>
          <template v-for="(match, index) in submit_match_accounts">
            <vs-list-item :key="index">
              <p class="p-2">{{ match.company_name }}</p>
              <p class="p-2">{{ match.registered_office_country }}</p>
              <p class="p-2">
                {{ match.company_registration_number
                }}<vs-icon
                  @click.stop="viewPotentialMatchAccountDetails(match)"
                  size="small"
                  icon="info"
                  style="cursor: pointer; margin-left: 15px"
                ></vs-icon>
              </p>
            </vs-list-item>
          </template>

          <div class="vx-row mt-5"></div>
        </vs-list>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import moduleAccountsManagement from '@/store/accounts-management/moduleAccountsManagement.js'
import _ from 'lodash'
import defineAbilitiesFor from '@/config/abilities'
import axios from '@/axios.js'
import moduleCampaignsManagement from '@/store/campaign-management/moduleCampaignManagement.js'
import AccountAutocomplete from '@/components/autocomplete/AccountsAutocomplete.vue'
import Autocomplete from '@/components/autocomplete/Autocomplete.vue'
import vSelect from 'vue-select'
import ProgressBar from 'vue-simple-progress'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { remove } from 'lodash'
export default {
  components: {
    Autocomplete,
    'v-select': vSelect,
    ProgressBar,
    flatPickr,
    AccountAutocomplete
  },
  computed: {
    total_pages () {
      console.log('totla', this.all_total)
      return Math.ceil(this.all_total / this.limit)
    }
    // cloneItems() {
    //     var clone = this.unmatch_accounts;
    //     var startFrom = (this.pagination.page*this.pagination.rowsPerPage)-this.pagination.rowsPerPage;
    //     return clone.splice(startFrom, this.pagination.rowsPerPage);
    // }
  },
  data () {
    return {
      update_account_and_add_to_campaign_heading:
        'Update Account and Add to Campaign',
      subsidiaryPopupActive: false,
      temp_table_id: null,
      submit_match_accounts: [],
      MatchedAccountsPopupActive: false,
      MatchedWebsitePopupActive: false,
      MatchedLinkedInPopupActive: false,
      showUpdateSatelliteOfficePopup: false,
      subsidiaryAccountDescription: {},
      updateSatelliteOfficeAccountDescription: {},
      updateSatelliteOfficePopupActive: false,
      all_phone_codes: [],
      head_office_country_validation: null,
      potential_account_matches: [],
      matched_websites: [],
      matched_linkedins: [],
      user_id: null,
      user_role: null,
      registered_office_country_validation: null,
      selected_parent_company: null,
      selected_registration_jurisdiction: null,
      selected_vertical: null,
      selected_sic_code: null,
      selected_registered_office_country: null,
      selected_head_office_country: null,
      satellite_office_currency_code_validation: null,
      currencyCodes: [],
      abilities: null,
      showHeadOfficeCountryField: true,
      showEditAutocomplete: false,
      telephone_show_no: 5,
      linkedin_show_no: 5,
      website_show_no: 5,
      accountDescription: {},
      popupActive: false,
      websiteExists: false,
      linkedinExists: false,
      parent_name: null,
      RegistrationJurisdiction: null,
      verticalName: null,
      headOfficeIsRegisteredOffice: false,
      satelliteOfficeheadOfficeIsRegisteredOffice: false,
      subsidiaryheadOfficeIsRegisteredOffice: false,
      overwriteDataBuildRegisteredOfficeAddressToMasterDB: false,
      overwriteDataBuildHeadOfficeAddressToMasterDB: false,
      old_head_office_address_1: null,
      old_head_office_address_2: null,
      old_head_office_address_3: null,
      old_head_office_city: null,
      old_head_office_county: null,
      old_head_office_postcode: null,
      old_head_office_country: null,
      old_head_office_address_1_update_satellite_office: null,
      old_head_office_address_2_update_satellite_office: null,
      old_head_office_address_3_update_satellite_office: null,
      old_head_office_city_update_satellite_office: null,
      old_head_office_county_update_satellite_office: null,
      old_head_office_postcode_update_satellite_office: null,
      old_head_office_country_update_satellite_office: null,
      old_registered_office_address_1_update_satellite_office: null,
      old_registered_office_address_2_update_satellite_office: null,
      old_registered_office_address_3_update_satellite_office: null,
      old_registered_office_city_update_satellite_office: null,
      old_registered_office_county_update_satellite_office: null,
      old_registered_office_postcode_update_satellite_office: null,
      old_registered_office_country_update_satellite_office: null,
      old_head_office_address_1_subsidiary: null,
      old_head_office_address_2_subsidiary: null,
      old_head_office_address_3_subsidiary: null,
      old_head_office_city_subsidiary: null,
      old_head_office_county_subsidiary: null,
      old_head_office_postcode_subsidiary: null,
      old_head_office_country_subsidiary: null,
      old_registered_office_address_1_subsidiary: null,
      old_registered_office_address_2_subsidiary: null,
      old_registered_office_address_3_subsidiary: null,
      old_registered_office_city_subsidiary: null,
      old_registered_office_county_subsidiary: null,
      old_registered_office_postcode_subsidiary: null,
      old_registered_office_country_subsidiary: null,
      old_company_registration_number: null,
      IsSoleTrader: false,
      registered_office_country_validation: null,
      head_office_country_validation: null,

      configDatePicker: {
        enableTime: false,
        dateFormat: 'Y-m-d',
        allowInvalidPreload: false
      },
      configDateAndTimePicker: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i:s',
        allowInvalidPreload: false,
        enableSeconds: true
      },
      PLeasewait: '',
      uploadPercentage: 0,
      all_unmatched_accounts: [],
      selected: [],
      allSelected: false,
      all_currency_codes: [],
      all_verticals: [],
      all_sic_codes: [],
      all_countries: [],
      accountDescription: {},
      mandatory_fields: [],
      all_phone_codes: [],
      selected_fields: null,
      phoneTypes: [],
      correction_fields_array: [],
      vertical: null,
      selected_vertical: null,
      correction_fields: null,
      selected_registration_jurisdiction: null,
      currencyCodes: [],
      selected_sic_code: null,
      add_or_update_title: null,
      user_id: null,
      user_role: null,
      selected_head_office_country: null,
      abilities: null,
      field_array_columns: [],
      actual_account_name: null,
      registered_office_address_1: null,
      registered_office_address_2: null,
      registered_office_address_3: null,
      registered_office_city: null,
      registered_office_county: null,
      registered_office_postcode: null,
      registered_office_country: null,
      head_office_address_1: null,
      head_office_address_2: null,
      head_office_address_3: null,
      head_office_city: null,
      head_office_county: null,
      head_office_postcode: null,
      company_category: null,
      sic_code: null,
      revenue: null,
      currency_code: null,
      registration_jurisdiction: null,
      no_of_employees: null,
      // sic_code_description: null,
      phone_type: null,
      phone_no: null,
      phone_code: null,
      website: null,
      linkedin: null,
      status: null,
      switchboard: null,
      switchboard_phone_code: null,
      site_switchboard: null,
      site_switchboard_phone_code: null,
      company_name: null,
      selected_fields: null,
      registered_office_country_validation: null,
      EnhancedHeadOfficeAutocompleteComponentKey: 0,
      EnhancedRegOfficeAutocompleteComponentKey: 0,
      EnhancedSicCodeAutocompleteComponentKey: 0,
      EnhancedVerticalAutocompleteComponentKey: 0,
      EnhancedRegistrationJurisdictionAutocompleteComponentKey: 0,
      company_registration_number: null,
      country: null,
      isNewAccount: null,
      update_id: null,
      table: null,
      popupActive: false,
      updateData: [],
      currency_code_validation: null,
      currencyCodes: [],
      abilities: null,
      showHeadOfficeCountryField: true,
      showEditAutocomplete: false,
      telephone_show_no: 5,
      linkedin_show_no: 5,
      website_show_no: 5,
      accountDescription: {},
      accountExists: false,
      websiteExists: false,
      linkedinExists: false,
      parent_name: null,
      RegistrationJurisdiction: null,
      verticalName: null,
      old_head_office_address_1: null,
      old_head_office_address_2: null,
      old_head_office_address_3: null,
      old_head_office_city: null,
      old_head_office_county: null,
      old_head_office_postcode: null,
      old_head_office_country: null,
      old_company_registration_number: null,
      accounts: {
        web: null,
        phone: null,
        linkedin: null,
        main_counter: 0,
        vertical: null,
        phoneTypes: [],
        phoneType: [],
        joinedPhoneAndTypes: [],
        joinedSicAndDescription: [],
        websites: [],
        linkedins: [],
        phoneWithTypes: [],
        sicCodeWithDescription: [],
        verticals: [],
        vertical: null,
        sic_code: null,
        sic_code_description: null,
        currency_code: null,
        revenue: null,
        no_of_employees: null,
        satellite_office: []
      },
      SatelliteOfficeaccounts: {
        web: null,
        phone: null,
        linkedin: null,
        main_counter: 0,
        vertical: null,
        phoneTypes: [],
        phoneType: [],
        joinedPhoneAndTypes: [],
        joinedSicAndDescription: [],
        websites: [],
        linkedins: [],
        phoneWithTypes: [],
        sicCodeWithDescription: [],
        verticals: [],
        vertical: null,
        sic_code: null,
        sic_code_description: null,
        currency_code: null,
        revenue: null,
        no_of_employees: null
      },
     subsidiaryaccounts: {
        web: null,
        phone: null,
        linkedin: null,
        main_counter: 0,
        vertical: null,
        phoneTypes: [],
        phoneType: [],
        joinedPhoneAndTypes: [],
        joinedSicAndDescription: [],
        websites: [],
        linkedins: [],
        phoneWithTypes: [],
        sicCodeWithDescription: [],
        verticals: [],
        vertical: null,
        sic_code: null,
        sic_code_description: null,
        currency_code: null,
        revenue: null,
        no_of_employees: null
      },
      accountDescription: {},
      addNewAccountsPopUp: false,
      campaignDescription: [],
      abilities: null,
      campaignId: null,
      componentKey: 0,
      limit: 1,
      currentx: 1,
      paginate: { limit: 1, offset: 0 },
      tableData: [],
      header: [],
      sheetName: '',
      list2: [],
      uploaded_columns: [],
      selected_fields: [
        'ml_company',
        'ml_actual_account_name',
        [
          [
            'Head Office Address',
            'Registered Office',
            'State',
            'Town',
            'Country',
            'Postal Code',
            'Site Office'
          ]
        ]
      ],
      unmatch_accounts: [],
      accept_text: 'Accept',
      acceptButtonColor: 'primary',
      accepted_matches: [],
      combined_matches: [],
      all_total: 0
    }
  },
     mounted () {
    this.getPhoneTypes()
    this.getCurrencyCodes()
    this.unmatchedIndividualBuildDataById()

    this.getCampaignDescription()
    this.getAllPhoneCodes()


    this.showUpdateSatelliteOfficePopup = false

      this.MatchedWebsitePopupActive = false

      this.MatchedLinkedInPopupActive = false

      this.MatchedAccountsPopupActive = false

      this.updateSatelliteOfficePopupActive = false

      this.subsidiaryPopupActive = false

  },
  watch: {
    website_show_no (val) {
      if (val) {
        this.accountDescription.webShow = this.accountDescription.web.slice(
          0,
          val
        )
      }
    },
    linkedin_show_no (val) {
      if (val) {
        this.accountDescription.linkedinShow =
          this.accountDescription.linkedin.slice(0, val)
      }
    },
    telephone_show_no (val) {
      if (val) {
        this.accountDescription.phone = this.accountDescription.phone.slice(
          0,
          val
        )
      }
    },
    headOfficeIsRegisteredOffice (val) {
      if (val) {
        this.accountDescription.head_office_address_1 =
          this.accountDescription.registered_office_address_1
        this.accountDescription.head_office_address_2 =
          this.accountDescription.registered_office_address_2
        this.accountDescription.head_office_address_3 =
          this.accountDescription.registered_office_address_3
        this.accountDescription.head_office_city =
          this.accountDescription.registered_office_city
        this.accountDescription.head_office_county =
          this.accountDescription.registered_office_county
        this.accountDescription.head_office_postcode =
          this.accountDescription.registered_office_postcode

        this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value =
          this.accountDescription.registered_office_country
        this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value =
          this.accountDescription.registered_office_country

        // this.accountDescription.head_office_country =
        //   this.accountDescription.registered_office_country
      } else {
        this.accountDescription.head_office_address_1 =
          this.old_head_office_address_1
        this.accountDescription.head_office_address_2 =
          this.old_head_office_address_2
        this.accountDescription.head_office_address_3 =
          this.old_head_office_address_3
        this.accountDescription.head_office_city = this.old_head_office_city
        this.accountDescription.head_office_county = this.old_head_office_county
        this.accountDescription.head_office_postcode =
          this.old_head_office_postcode
        // this.accountDescription.head_office_country =
        //   this.old_head_office_country

        this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value =
          this.old_head_office_country
        this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value =
          this.old_head_office_country
      }
    },
    satelliteOfficeheadOfficeIsRegisteredOffice (val) {
      console.log('val', this.old_head_office_address_1_update_satellite_office)

      if (val) {
        this.updateSatelliteOfficeAccountDescription.head_office_address_1 =
          this.updateSatelliteOfficeAccountDescription.registered_office_address_1
        this.updateSatelliteOfficeAccountDescription.head_office_address_2 =
          this.updateSatelliteOfficeAccountDescription.registered_office_address_2
        this.updateSatelliteOfficeAccountDescription.head_office_address_3 =
          this.updateSatelliteOfficeAccountDescription.registered_office_address_3
        this.updateSatelliteOfficeAccountDescription.head_office_city =
          this.updateSatelliteOfficeAccountDescription.registered_office_city
        this.updateSatelliteOfficeAccountDescription.head_office_county =
          this.updateSatelliteOfficeAccountDescription.registered_office_county
        this.updateSatelliteOfficeAccountDescription.head_office_postcode =
          this.updateSatelliteOfficeAccountDescription.registered_office_postcode

        this.$refs.SatelliteOfficeaccountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value =
          this.updateSatelliteOfficeAccountDescription.registered_office_country
        this.$refs.SatelliteOfficeaccountEditHeadOfficeCountryRef.$refs.suggestComponent.value =
          this.updateSatelliteOfficeAccountDescription.registered_office_country
      } else {
        this.updateSatelliteOfficeAccountDescription.head_office_address_1 =
          this.old_head_office_address_1_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.head_office_address_2 =
          this.old_head_office_address_2_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.head_office_address_3 =
          this.old_head_office_address_3_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.head_office_city =
          this.old_head_office_city_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.head_office_county =
          this.old_head_office_county_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.head_office_postcode =
          this.old_head_office_postcode_update_satellite_office

        this.$refs.SatelliteOfficeaccountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value =
          this.old_head_office_country_update_satellite_office
        this.$refs.SatelliteOfficeaccountEditHeadOfficeCountryRef.$refs.suggestComponent.value =
          this.old_head_office_country_update_satellite_office
      }
    },
     subsidiaryheadOfficeIsRegisteredOffice (val) {

      if (val) {
        this.subsidiaryAccountDescription.head_office_address_1 =
          this.subsidiaryAccountDescription.registered_office_address_1
        this.subsidiaryAccountDescription.head_office_address_2 =
          this.subsidiaryAccountDescription.registered_office_address_2
        this.subsidiaryAccountDescription.head_office_address_3 =
          this.subsidiaryAccountDescription.registered_office_address_3
        this.subsidiaryAccountDescription.head_office_city =
          this.subsidiaryAccountDescription.registered_office_city
        this.subsidiaryAccountDescription.head_office_county =
          this.subsidiaryAccountDescription.registered_office_county
        this.subsidiaryAccountDescription.head_office_postcode =
          this.subsidiaryAccountDescription.registered_office_postcode



        this.$refs.subsidiaryaccountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value =
          this.subsidiaryAccountDescription.registered_office_country
        this.$refs.subsidiaryaccountEditHeadOfficeCountryRef.$refs.suggestComponent.value =
          this.subsidiaryAccountDescription.registered_office_country
      } else {
        this.subsidiaryAccountDescription.head_office_address_1 =
          this.old_head_office_address_1_subsidiary
        this.subsidiaryAccountDescription.head_office_address_2 =
          this.old_head_office_address_2_subsidiary
        this.subsidiaryAccountDescription.head_office_address_3 =
          this.old_head_office_address_3_subsidiary
        this.subsidiaryAccountDescription.head_office_city =
          this.old_head_office_city_subsidiary
        this.subsidiaryAccountDescription.head_office_county =
          this.old_head_office_county_subsidiary
        this.subsidiaryAccountDescription.head_office_postcode =
          this.old_head_office_postcode_subsidiary

        this.$refs.subsidiaryaccountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value =
          this.old_head_office_country_subsidiary
        this.$refs.subsidiaryaccountEditHeadOfficeCountryRef.$refs.suggestComponent.value =
          this.old_head_office_country_subsidiary
      }
    },
    overwriteDataBuildRegisteredOfficeAddressToMasterDB (val) {
      console.log('overwriteDataBuildAddressToMasterDB', val)

      if (val) {
        this.updateSatelliteOfficeAccountDescription.registered_office_address_1 =
          this.accountDescription.registered_office_address_1
        this.updateSatelliteOfficeAccountDescription.registered_office_address_2 =
          this.accountDescription.registered_office_address_2
        this.updateSatelliteOfficeAccountDescription.registered_office_address_3 =
          this.accountDescription.registered_office_address_3
        this.updateSatelliteOfficeAccountDescription.registered_office_city =
          this.accountDescription.registered_office_city
        this.updateSatelliteOfficeAccountDescription.registered_office_county =
          this.accountDescription.registered_office_county
        this.updateSatelliteOfficeAccountDescription.registered_office_postcode =
          this.accountDescription.registered_office_postcode

        this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value =
          this.accountDescription.registered_office_country
        this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value =
          this.accountDescription.registered_office_country
      } else {
        this.updateSatelliteOfficeAccountDescription.registered_office_address_1 =
          this.old_registered_office_address_1_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.registered_office_address_2 =
          this.old_registered_office_address_2_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.registered_office_address_3 =
          this.old_registered_office_address_3_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.registered_office_city =
          this.old_registered_office_city_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.registered_office_county =
          this.old_registered_office_county_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.registered_office_postcode =
          this.old_registered_office_postcode_update_satellite_office

        this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value =
          this.old_registered_office_country_update_satellite_office
        this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value =
          this.old_registered_office_country_update_satellite_office
      }
    },
    overwriteDataBuildHeadOfficeAddressToMasterDB (val) {
      console.log('overwriteDataBuildHeadOfficeAddressToMasterDB', val)

      if (val) {
        this.updateSatelliteOfficeAccountDescription.head_office_address_1 =
          this.accountDescription.head_office_address_1
        this.updateSatelliteOfficeAccountDescription.head_office_address_2 =
          this.accountDescription.head_office_address_2
        this.updateSatelliteOfficeAccountDescription.head_office_address_3 =
          this.accountDescription.head_office_address_3
        this.updateSatelliteOfficeAccountDescription.head_office_city =
          this.accountDescription.head_office_city
        this.updateSatelliteOfficeAccountDescription.head_office_county =
          this.accountDescription.head_office_county
        this.updateSatelliteOfficeAccountDescription.head_office_postcode =
          this.accountDescription.head_office_postcode

        this.$refs.SatelliteOfficeaccountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value =
          this.accountDescription.head_office_country
        this.$refs.SatelliteOfficeaccountEditHeadOfficeCountryRef.$refs.suggestComponent.value =
          this.accountDescription.head_office_country
      } else {
        this.updateSatelliteOfficeAccountDescription.head_office_address_1 =
          this.old_head_office_address_1_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.head_office_address_2 =
          this.old_head_office_address_2_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.head_office_address_3 =
          this.old_head_office_address_3_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.head_office_city =
          this.old_head_office_city_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.head_office_county =
          this.old_head_office_county_update_satellite_office
        this.updateSatelliteOfficeAccountDescription.head_office_postcode =
          this.old_head_office_postcode_update_satellite_office

        this.$refs.SatelliteOfficeaccountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value =
          this.old_head_office_country_update_satellite_office
        this.$refs.SatelliteOfficeaccountEditHeadOfficeCountryRef.$refs.suggestComponent.value =
          this.old_head_office_country_update_satellite_office
      }
    },
    'accounts.websites' (val) {
      if (val) {
        var lastItem = val[val.length - 1]
        if (this.validDomain(lastItem)) {
          this.$store
            .dispatch('accountsManagement/checkWebsiteExists', lastItem)
            .then(res => {
              if (res.data.status == 'fail') {
                this.websiteExists = true
                this.$vs.dialog({
                  color: 'primary',
                  title: `Confirm`,
                  text: 'This website already exists.',
                  accept: (this.websiteExists = false)
                })
                var index = this.accounts.websites.indexOf(lastItem)
                this.accounts.websites.splice(index, 1)
              } else {
                return
              }
            })
            .catch(err => {
              if (err.response.status === 401) {
                this.$router.replace('/login')
              }
            })
        } else {
          var index = this.accounts.websites.indexOf(lastItem)
          this.accounts.websites.splice(index, 1)
          return false
        }
      }
    },
    'accounts.linkedins' (val) {
      if (val) {
        var lastItem = val[val.length - 1]
        if (this.validDomain(lastItem)) {
          this.$store
            .dispatch('accountsManagement/checkLinkedinExists', lastItem)
            .then(res => {
              if (res.data.status == 'fail') {
                this.linkedinExists = true
                this.$vs.dialog({
                  color: 'primary',
                  title: `Confirm`,
                  text: 'This linkedin already exists.',
                  accept: (this.linkedinExists = false)
                })
                var index = this.accounts.linkedins.indexOf(lastItem)
                this.accounts.linkedins.splice(index, 1)
              } else {
                return
              }
            })
            .catch(err => {
              if (err.response.status === 401) {
                this.$router.replace('/login')
              }
            })
        } else {
          var index = this.accounts.linkedins.indexOf(lastItem)
          this.accounts.linkedins.splice(index, 1)
          return false
        }
      }
    },
    'SatelliteOfficeaccounts.websites' (val) {
      if (val) {
        var lastItem = val[val.length - 1]
        if (this.validDomain(lastItem)) {
          this.$store
            .dispatch('accountsManagement/checkWebsiteExists', lastItem)
            .then(res => {
              if (res.data.status == 'fail') {
                this.websiteExists = true
                this.$vs.dialog({
                  color: 'primary',
                  title: `Confirm`,
                  text: 'This website already exists.',
                  accept: (this.websiteExists = false)
                })
                var index = this.accounts.websites.indexOf(lastItem)
                this.accounts.websites.splice(index, 1)
              } else {
                return
              }
            })
            .catch(err => {
              if (err.response.status === 401) {
                this.$router.replace('/login')
              }
            })
        } else {
          var index = this.accounts.websites.indexOf(lastItem)
          this.accounts.websites.splice(index, 1)
          return false
        }
      }
    },
    'SatelliteOfficeaccounts.linkedins' (val) {
      if (val) {
        var lastItem = val[val.length - 1]
        if (this.validDomain(lastItem)) {
          this.$store
            .dispatch('accountsManagement/checkLinkedinExists', lastItem)
            .then(res => {
              if (res.data.status == 'fail') {
                this.linkedinExists = true
                this.$vs.dialog({
                  color: 'primary',
                  title: `Confirm`,
                  text: 'This linkedin already exists.',
                  accept: (this.linkedinExists = false)
                })
                var index = this.accounts.linkedins.indexOf(lastItem)
                this.accounts.linkedins.splice(index, 1)
              } else {
                return
              }
            })
            .catch(err => {
              if (err.response.status === 401) {
                this.$router.replace('/login')
              }
            })
        } else {
          var index = this.accounts.linkedins.indexOf(lastItem)
          this.accounts.linkedins.splice(index, 1)
          return false
        }
      }
    },
    currentx: function (val, oldVal) {
      this.unmatch_accounts = this.all_unmatched_accounts.slice(
        (val - 1) * this.limit,
        val * this.limit
      )

      console.log('currentx', val)

      this.writeMasterDatabaseAndMatch(this.all_unmatched_accounts[val - 1])
    }
  },
  methods: {
   unmatchedIndividualBuildDataById () {
      let self = this
      this.$vs.loading()
      let data = {}
      data.campaignId = this.campaignId
      data.user_id = this.user_id
      data.table_id = this.$route.params.tableId
      axios
        .post(
          this.$base_url +
            '/api/accounts/get_unmatched_individual_build_accounts_by_id',
          data
        )
        .then(response => {
          let response_data = JSON.parse(response.data)

          self.unmatch_accounts = response_data.rows.slice(
            (self.currentx - 1) * self.limit,
            self.currentx * self.limit
          )

          self.all_unmatched_accounts = response_data.rows

          self.all_unmatched_accounts = self.all_unmatched_accounts.map(el => {

             if(el.Phone == undefined)
            {
              el.Phone = ''
          }


            if ('Phone' in el && (el.Phone !== null && el.Phone !== '')) {
            el.Phone_no = el.Phone
            }


            let resultobj = {}
            Object.entries(el).map(([key, val]) => {
              resultobj[
                key.split(' ').join('_').replace(/\W+/g, '').toLowerCase()
              ] = val
              return resultobj
            })
            return resultobj
          })


          self.writeMasterDatabaseAndMatch(self.all_unmatched_accounts[0])

          let total = response_data.total_pages
          self.all_total = total

          self.field_array_columns = response_data.campaign_table_data

          // this.table = response_data.campaign_table_data[0]['table_name'];
          self.$vs.loading.close()
        })
        .catch(error => {
          console.log(error)
        })
    },
    closeShowSchedulePopup (value) {
      if (!value) this.subsidiaryPopupActive = true
    },
    cancelSubsidiaryForm () {
      this.showUpdateSatelliteOfficePopup = false

      this.MatchedWebsitePopupActive = false

      this.MatchedLinkedInPopupActive = false

      this.MatchedAccountsPopupActive = false

      this.updateSatelliteOfficePopupActive = false

      this.subsidiaryPopupActive = false

      // Get a reference to the element with the ID "myElement"
      const myElement = document.getElementById('subsidiaryPopup')

      // Check if the element exists before attempting to modify its style
      if (myElement) {
        // Set the display property to 'none' to hide the element
        myElement.style.display = 'none'
      }
    },
    cancelSatelliteOfficeForm () {
      let self = this

      self.showUpdateSatelliteOfficePopup = false

      self.MatchedWebsitePopupActive = false

      self.MatchedLinkedInPopupActive = false

      self.MatchedAccountsPopupActive = false

      self.updateSatelliteOfficePopupActive = false

      self.subsidiaryPopupActive = false

      // Get a reference to the element with the ID "myElement"
      const myElement = document.getElementById('satelliteOfficePopup')

      // Check if the element exists before attempting to modify its style
      if (myElement) {
        // Set the display property to 'none' to hide the element
        myElement.style.display = 'none'
      }
    },

    viewPotentialMatchAccountDetails (account) {
      let self = this


      self.$validator.errors.clear()
      self.update_account_and_add_to_campaign_heading =
        'Matched Account Details'
      let updateSatelliteOfficeAccountId = account.id
      this.$store
        .dispatch(
          'accountsManagement/fetchAccount',
          updateSatelliteOfficeAccountId
        )
        .then(res => {
          this.updateSatelliteOfficeAccountDescription = res.data
          this.old_head_office_address_1_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.head_office_address_1
          this.old_head_office_address_2_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.head_office_address_2
          this.old_head_office_address_3_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.head_office_address_3
          this.old_head_office_city_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.head_office_city
          this.old_head_office_county_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.head_office_county
          this.old_head_office_postcode_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.head_office_postcode

          this.$refs.SatelliteOfficeaccountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value =
            this.updateSatelliteOfficeAccountDescription.head_office_country
          this.$refs.SatelliteOfficeaccountEditHeadOfficeCountryRef.$refs.suggestComponent.value =
            this.updateSatelliteOfficeAccountDescription.head_office_country

          this.old_head_office_country_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.head_office_country

          this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value =
            this.updateSatelliteOfficeAccountDescription.registered_office_country
          this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value =
            this.updateSatelliteOfficeAccountDescription.registered_office_country

          this.old_registered_office_address_1_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.registered_office_address_1
          this.old_registered_office_address_2_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.registered_office_address_2
          this.old_registered_office_address_3_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.registered_office_address_3
          this.old_registered_office_city_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.registered_office_city
          this.old_registered_office_county_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.registered_office_county
          this.old_registered_office_postcode_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.registered_office_postcode

          this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value =
            this.updateSatelliteOfficeAccountDescription.registered_office_country
          this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value =
            this.updateSatelliteOfficeAccountDescription.registered_office_country

          this.old_registered_office_country_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.registered_office_country

          this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value =
            this.updateSatelliteOfficeAccountDescription.registered_office_country
          this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value =
            this.updateSatelliteOfficeAccountDescription.registered_office_country

          this.old_company_registration_number =
            this.updateSatelliteOfficeAccountDescription.company_registration_number

          this.updateSatelliteOfficeAccountDescription.phone =
            this.updateSatelliteOfficeAccountDescription.phone.slice(
              0,
              this.telephone_show_no
            )
          if (this.updateSatelliteOfficeAccountDescription.parent) {
            this.satelliteOfficeShowParentName(
              this.updateSatelliteOfficeAccountDescription.parent
            )
          }

          if (
            this.updateSatelliteOfficeAccountDescription
              .registration_jurisdiction
          ) {
            this.satelliteOfficeShowRegistrationJurisdiction(
              this.updateSatelliteOfficeAccountDescription
                .registration_jurisdiction
            )
          }
          if (this.updateSatelliteOfficeAccountDescription.vertical) {
            this.satelliteOfficeShowVertical(
              this.updateSatelliteOfficeAccountDescription.vertical
            )
          }

          this.updateSatelliteOfficeAccountDescription.phone.forEach(function (
            ele
          ) {
            ele.phone_type.forEach(function (phoneTypeEle, index) {
              ele.phone_type = phoneTypeEle.type
                .replaceAll('_', ' ')
                .replace(/\b\w/g, l => l.toUpperCase())
            })
          })

          var self = this

          this.$store
            .dispatch('accountsManagement/getCurrencyCodes')
            .then(response => {
              let result = response.data

              if (self.updateSatelliteOfficeAccountDescription.currency_code) {
                result.forEach(function (ele) {
                  if (
                    ele.id ==
                    self.updateSatelliteOfficeAccountDescription.currency_code
                  ) {
                    self.updateSatelliteOfficeAccountDescription.currency_code =
                      ele.symbol + ' ' + ele.name + ' ' + ele.code
                  }
                })
              }
            })
            .catch(err => {
              if (err.response.status === 404) {
                console.log('Error')
                return
              }
              console.error(err)
            })

          this.updateSatelliteOfficeAccountDescription.satellite_office =
            this.updateSatelliteOfficeAccountDescription.satellite_office.map(
              ele => {
                let counter = 0
                ele.counter = ++this.SatelliteOfficeaccounts.main_counter
                return ele
              }
            )

          // this.accounts.joinedSicAndDescription = this.updateSatelliteOfficeAccountDescription.sic_code
          this.updateSatelliteOfficeAccountDescription.sic_code.forEach(
            function (e) {
              let mapped = {}
              ;(mapped.id = e.sic_code_detail.id),
                (mapped.name =
                  e.sic_code_detail.code +
                  ' - ' +
                  e.sic_code_detail.description)
              self.accounts.joinedSicAndDescription.push(mapped)
            }
          )
        })

      self.showUpdateSatelliteOfficePopup = true

      self.MatchedWebsitePopupActive = false

      self.MatchedLinkedInPopupActive = false

      self.MatchedAccountsPopupActive = false

      self.updateSatelliteOfficePopupActive = true

      self.subsidiaryPopupActive = false
    },

     viewSubsidiaryAccountDetails (account) {
      console.log('account', account)

      let self = this

      self.$validator.errors.clear()

      
      let updatesubsidiaryAccountId = account.id
      this.$store
        .dispatch(
          'accountsManagement/fetchAccount',
          updatesubsidiaryAccountId
        )
        .then(res => {
          this.subsidiaryAccountDescription = res.data
          this.old_head_office_address_1_subsidiary =
            this.subsidiaryAccountDescription.head_office_address_1
          this.old_head_office_address_2_subsidiary =
            this.subsidiaryAccountDescription.head_office_address_2
          this.old_head_office_address_3_subsidiary =
            this.subsidiaryAccountDescription.head_office_address_3
          this.old_head_office_city_subsidiary =
            this.subsidiaryAccountDescription.head_office_city
          this.old_head_office_county_subsidiary =
            this.subsidiaryAccountDescription.head_office_county
          this.old_head_office_postcode_subsidiary =
            this.subsidiaryAccountDescription.head_office_postcode

          this.$refs.subsidiaryaccountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value =
            this.subsidiaryAccountDescription.head_office_country
          this.$refs.subsidiaryaccountEditHeadOfficeCountryRef.$refs.suggestComponent.value =
            this.subsidiaryAccountDescription.head_office_country

          this.old_head_office_country_subsidiary =
            this.subsidiaryAccountDescription.head_office_country

          this.$refs.subsidiaryaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value =
            this.subsidiaryAccountDescription.registered_office_country
          this.$refs.subsidiaryaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value =
            this.subsidiaryAccountDescription.registered_office_country

          this.old_company_registration_number =
            this.subsidiaryAccountDescription.company_registration_number

          this.subsidiaryAccountDescription.phone =
            this.subsidiaryAccountDescription.phone.slice(
              0,
              this.telephone_show_no
            )
          if (this.subsidiaryAccountDescription.parent) {
            this.subsidiaryShowParentName(
              this.subsidiaryAccountDescription.parent
            )
          }

          if (
            this.subsidiaryAccountDescription
              .registration_jurisdiction
          ) {
            this.subsidiaryShowRegistrationJurisdiction(
              this.subsidiaryAccountDescription
                .registration_jurisdiction
            )
          }
          if (this.subsidiaryAccountDescription.vertical) {
            this.subsidiaryShowVertical(
              this.subsidiaryAccountDescription.vertical
            )
          }

          this.subsidiaryAccountDescription.phone.forEach(function (
            ele
          ) {
            ele.phone_type.forEach(function (phoneTypeEle, index) {
              ele.phone_type = phoneTypeEle.type
                .replaceAll('_', ' ')
                .replace(/\b\w/g, l => l.toUpperCase())
            })
          })
          var self = this

          this.$store
            .dispatch('accountsManagement/getCurrencyCodes')
            .then(response => {
              let result = response.data

              if (self.subsidiaryAccountDescription.currency_code) {
                result.forEach(function (ele) {
                  if (
                    ele.id ==
                    self.subsidiaryAccountDescription.currency_code
                  ) {
                    self.subsidiaryAccountDescription.currency_code =
                      ele.symbol + ' ' + ele.name + ' ' + ele.code
                  }
                })
              }
            })
            .catch(err => {
              if (err.response.status === 404) {
                console.log('Error')
                return
              }
              console.error(err)
            })

          this.subsidiaryAccountDescription.satellite_office =
            this.subsidiaryAccountDescription.satellite_office.map(
              ele => {
                let counter = 0
                ele.counter = ++this.subsidiaryaccounts.main_counter
                return ele
              }
            )

          // this.accounts.joinedSicAndDescription = this.subsidiaryAccountDescription.sic_code
          this.subsidiaryAccountDescription.sic_code.forEach(
            function (e) {
              let mapped = {}
              ;(mapped.id = e.sic_code_detail.id),
                (mapped.name =
                  e.sic_code_detail.code +
                  ' - ' +
                  e.sic_code_detail.description)
              self.accounts.joinedSicAndDescription.push(mapped)
            }
          )
        })

      self.MatchedWebsitePopupActive = false

      self.MatchedLinkedInPopupActive = false

      self.MatchedAccountsPopupActive = false

      self.subsidiaryPopupActive = true



    },

    getAllPhoneCodes () {
      let self = this
      this.$store
        .dispatch('accountsManagement/getAllPhoneCodes')
        .then(response => {
          self.all_phone_codes = response.data
          self.all_countries = response.data
          self.all_phone_codes.forEach(function (ele) {
            if (ele.phone_code) {
              ele.name_with_code = ele.phone_code + ' - ' + ele.name_1
            }
            return ele
          })
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    handleUpdateSatelliteOfficeEvent () {
      let self = this

            self.$validator.errors.clear()


      self.update_account_and_add_to_campaign_heading =
        'Update Satellite Office'

      let updateSatelliteOfficeAccountId =
        moduleAccountsManagement.autocomplete_selected.id
      this.$store
        .dispatch(
          'accountsManagement/fetchAccount',
          updateSatelliteOfficeAccountId
        )
        .then(res => {
          this.updateSatelliteOfficeAccountDescription = res.data
          this.old_head_office_address_1_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.head_office_address_1
          this.old_head_office_address_2_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.head_office_address_2
          this.old_head_office_address_3_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.head_office_address_3
          this.old_head_office_city_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.head_office_city
          this.old_head_office_county_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.head_office_county
          this.old_head_office_postcode_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.head_office_postcode

          this.$refs.SatelliteOfficeaccountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value =
            this.updateSatelliteOfficeAccountDescription.head_office_country
          this.$refs.SatelliteOfficeaccountEditHeadOfficeCountryRef.$refs.suggestComponent.value =
            this.updateSatelliteOfficeAccountDescription.head_office_country

          this.old_head_office_country_update_satellite_office =
            this.updateSatelliteOfficeAccountDescription.head_office_country

          this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value =
            this.updateSatelliteOfficeAccountDescription.registered_office_country
          this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value =
            this.updateSatelliteOfficeAccountDescription.registered_office_country

          this.old_company_registration_number =
            this.updateSatelliteOfficeAccountDescription.company_registration_number

          this.updateSatelliteOfficeAccountDescription.phone =
            this.updateSatelliteOfficeAccountDescription.phone.slice(
              0,
              this.telephone_show_no
            )

          let satellite_office_switchboard_phone_code = null
          let satellite_office_switchboard_phone = null
          let account_description_switchboard_phone_code = null
          let account_description_switchboard_phone = null

          this.updateSatelliteOfficeAccountDescription.phone.forEach(function (
            ele
          ) {
            ele.phone_type.forEach(function (phoneTypeEle) {
              if (phoneTypeEle.type == 'head_office_switchboard') {
                satellite_office_switchboard_phone_code = ele.phone_code
                satellite_office_switchboard_phone = ele.phone_no
              }
            })
          })

          this.accountDescription.phone.forEach(function (ele) {
            if (ele.phone_type == 'Head Office Switchboard') {
              account_description_switchboard_phone_code = ele.phone_code
              account_description_switchboard_phone = ele.phone_no
            }
          })

          this.updateSatelliteOfficeAccountDescription.satellite_office.push({
            counter: 1,
            address_1: this.accountDescription.head_office_address_1,
            address_2: this.accountDescription.head_office_address_2,
            address_3: this.accountDescription.head_office_address_3,
            city: this.accountDescription.head_office_city,
            county: this.accountDescription.head_office_county,
            postcode: this.accountDescription.head_office_postcode,
            country: this.accountDescription.head_office_country
          })

          let a_d_phone =
            account_description_switchboard_phone_code +
            ' - ' +
            account_description_switchboard_phone
          let s_o_phone =
            satellite_office_switchboard_phone_code +
            ' - ' +
            satellite_office_switchboard_phone

          if (s_o_phone != a_d_phone) {
            this.updateSatelliteOfficeAccountDescription.satellite_office[0].phone_no =
              account_description_switchboard_phone
            this.updateSatelliteOfficeAccountDescription.satellite_office[0].phone_code =
              account_description_switchboard_phone_code
          }

          if (this.updateSatelliteOfficeAccountDescription.parent) {
            this.satelliteOfficeShowParentName(
              this.updateSatelliteOfficeAccountDescription.parent
            )
          }

          if (
            this.updateSatelliteOfficeAccountDescription
              .registration_jurisdiction
          ) {
            this.satelliteOfficeShowRegistrationJurisdiction(
              this.updateSatelliteOfficeAccountDescription
                .registration_jurisdiction
            )
          }
          if (this.updateSatelliteOfficeAccountDescription.vertical) {
            this.satelliteOfficeShowVertical(
              this.updateSatelliteOfficeAccountDescription.vertical
            )
          }

          this.updateSatelliteOfficeAccountDescription.phone.forEach(function (
            ele
          ) {
            ele.phone_type.forEach(function (phoneTypeEle, index) {
              ele.phone_type = phoneTypeEle.type
                .replaceAll('_', ' ')
                .replace(/\b\w/g, l => l.toUpperCase())
            })
          })

          console.log(
            'this.updateSatelliteOfficeAccountDescription.phone',
            this.updateSatelliteOfficeAccountDescription.phone
          )

          var self = this

          this.$store
            .dispatch('accountsManagement/getCurrencyCodes')
            .then(response => {
              let result = response.data

              if (self.updateSatelliteOfficeAccountDescription.currency_code) {
                result.forEach(function (ele) {
                  if (
                    ele.id ==
                    self.updateSatelliteOfficeAccountDescription.currency_code
                  ) {
                    self.updateSatelliteOfficeAccountDescription.currency_code =
                      ele.symbol + ' ' + ele.name + ' ' + ele.code
                  }
                })
              }
            })
            .catch(err => {
              if (err.response.status === 404) {
                console.log('Error')
                return
              }
              console.error(err)
            })

          this.updateSatelliteOfficeAccountDescription.satellite_office =
            this.updateSatelliteOfficeAccountDescription.satellite_office.map(
              ele => {
                let counter = 0
                ele.counter = ++this.SatelliteOfficeaccounts.main_counter
                return ele
              }
            )

          self.SatelliteOfficeaccounts.joinedSicAndDescription = []

          console.log(
            'this.SatelliteOfficeaccounts.sic_code',
            this.SatelliteOfficeaccounts.sic_code
          )

          if (
            this.SatelliteOfficeaccounts.sic_code == null ||
            this.SatelliteOfficeaccounts.sic_code == undefined
          ) {
            this.SatelliteOfficeaccounts.sic_code = []
          }
          this.SatelliteOfficeaccounts.sic_code.forEach(function (e) {
            let mapped = {}
            ;(mapped.id = e.sic_code_detail.id),
              (mapped.name =
                e.sic_code_detail.code + ' - ' + e.sic_code_detail.description)
            self.SatelliteOfficeaccounts.joinedSicAndDescription.push(mapped)
          })
        })

      self.showUpdateSatelliteOfficePopup = true

      self.updateSatelliteOfficePopupActive = true

      self.MatchedWebsitePopupActive = false

      self.MatchedAccountsPopupActive = false

      self.MatchedLinkedInPopupActive = false

      self.subsidiaryPopupActive = false
    },
    acceptAlert () {
      this.addNewAccountsPopUp = true
    },
    writeMasterDatabaseAndMatch (data) {
      this.correction_fields_array = []
      this.isNewAccount = 'Y'
      this.add_or_update_title = 'Please update the field and submit'

      this.accountDescription = data
      let website_url = []
      if (this.accountDescription.website != null) {
        website_url.push({ url: this.accountDescription.website })
      }
      this.accountDescription.web = website_url

      let linkedin_url = []
      if (this.accountDescription.linkendin != null) {
        linkedin_url.push({ url: this.accountDescription.linkendin })
      }
      this.accountDescription.linkedin = linkedin_url

      this.accountDescription.id = data.id
      this.temp_table_id = data.id

      this.accounts.satellite_office = []

      // this.accountDescription.no_of_employees =
      //   this.accountDescription.employees

      this.accountDescription.status = this.accountDescription.company_status

      this.old_head_office_address_1 =
        this.accountDescription.head_office_address_1
      this.old_head_office_address_2 =
        this.accountDescription.head_office_address_2
      this.old_head_office_address_3 =
        this.accountDescription.head_office_address_3
      this.old_head_office_city = this.accountDescription.head_office_city
      this.old_head_office_county = this.accountDescription.head_office_county
      this.old_head_office_postcode =
        this.accountDescription.head_office_postcode

      if (this.accountDescription.head_office_country != undefined) {
        this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value =
          this.accountDescription.head_office_country
        this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value =
          this.accountDescription.head_office_country
        this.old_head_office_country =
          this.accountDescription.head_office_country
      }

      if (this.accountDescription.registered_office_country != undefined) {
        this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value =
          this.accountDescription.registered_office_country
        this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value =
          this.accountDescription.registered_office_country
      }

      this.old_company_registration_number =
        this.accountDescription.company_registration_number

      if (
        this.accountDescription.parent != null &&
        this.accountDescription.parent != ''
      ) {
        this.showParentNameByValue(this.accountDescription.parent)
      } else {
        if (this.accountDescription.parent != undefined) {
          this.$refs.EditAccountParentRef.$refs.suggestComponent.input.value =
            this.accountDescription.parent
          this.$refs.EditAccountParentRef.$refs.suggestComponent.value =
            this.accountDescription.parent
        }
      }

      if (
        this.accountDescription.company_jurisdiction != null &&
        this.accountDescription.company_jurisdiction != ''
      ) {
        this.showRegistrationJurisdictionByvalue(
          this.accountDescription.company_jurisdiction
        )
      } else {
        if (this.accountDescription.company_jurisdiction != undefined) {
          this.$refs.EditAccountRegistrationJurisdictionRef.$refs.suggestComponent.input.value =
            this.accountDescription.company_jurisdiction

          this.$refs.EditAccountRegistrationJurisdictionRef.$refs.suggestComponent.value =
            this.accountDescription.company_jurisdiction
        }
      }

      if (
        this.accountDescription.vertical != null &&
        this.accountDescription.vertical != ''
      ) {
        this.showVerticalByValue(this.accountDescription.vertical)
      } else {
        if (this.accountDescription.vertical != undefined) {
          this.$refs.EditAccountVerticalRef.$refs.suggestComponent.input.value =
            this.accountDescription.vertical

          this.$refs.EditAccountVerticalRef.$refs.suggestComponent.value =
            this.accountDescription.vertical
        }
      }

      this.accountDescription.phone = []
      if (
        this.accountDescription.switchboard != null &&
        this.accountDescription.switchboard_phone_code != ''
      ) {
        this.accountDescription.phone.push({
          phone_code: this.accountDescription.switchboard_phone_code,
          phone_no: this.accountDescription.switchboard,
          phone_type: 'Head Office Switchboard'
        })
      }

      if (
        this.accountDescription.phone_no != null &&
        this.accountDescription.phone_code != '' &&
        this.accountDescription.phone_type != ''
      ) {
        this.accountDescription.phone.push({
          phone_code: this.accountDescription.phone_code,
          phone_no: this.accountDescription.phone_no,
          phone_type: this.accountDescription.phone_type
        })
      }

      if (
        this.accountDescription.sic_code != null &&
        this.accountDescription.sic_code != ''
      ) {
        this.showSICCodeByValue(this.accountDescription.sic_code)
      }

      var self = this

      this.$store
        .dispatch('accountsManagement/getCurrencyCodes')
        .then(response => {
          let result = response.data

          if (self.accountDescription.currency_code) {
            result.forEach(function (ele) {
              if (ele.id == self.accountDescription.currency_code) {
                self.accountDescription.currency_code =
                  ele.symbol + ' ' + ele.name + ' ' + ele.code
              }
            })
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            console.log('Error')
            return
          }
          console.error(err)
        })

      this.getPotentialMatchesForDataBuild()

      this.getCorrectionFields()

      this.addNewAccountsPopUp = true
    },
    dropAccountsFromCampaign (data) {
      this.accountDescription = data
      this.accountDescription.campaignId = this.$route.params.campaignId
      this.$store
        .dispatch(
          'accountsManagement/dropAccountsFromCampaign',
          this.accountDescription
        )
        .then(res => {
          if (res) {
            this.$vs.notify({
              color: 'success',
              title: 'Account',
              text: 'The account was removed successfully'
            })
            this.unmatchedIndividualBuildData()
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    forceRerender () {
      this.componentKey += 1
    },
    getCampaignDescription () {
      const campaignId = this.$route.params.campaignId
      this.$store
        .dispatch('campaignsManagement/fetchCampaign', campaignId)
        .then(res => {
          this.campaignDescription = res.data
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true
            return
          }
          console.error(err)
        })
    },
    acceptedIds (ids) {
      let self = this
      self.$vs.loading()

      ids.forEach(function (ie) {
        self.combined_matches.push(ie)
        self.combined_matches.map(function (ce) {
          if (ie.slave_id == ce.slave_id) {
            return (ce.uuid = ie.master_id)
          }
        })
        self.combined_matches = self.combined_matches.filter(
          (v, i, a) => a.findIndex(t => t.slave_id === v.slave_id) === i
        )
      })

      self.combined_matches = self.combined_matches.map(function (ele) {
        ele.campaignId = self.campaignId
        return ele
      })

      axios
        .post(
          this.$base_url + '/api/matched_accounts/save_matched_account',
          self.combined_matches
        )
        .then(response => {
          if (response.data.status == 'success') {
            self.$vs.notify({
              color: 'success',
              title: 'Account Matched',
              text: 'The account was matched successfully'
            })

            self.componentKey += 1
          }
          self.unmatchedIndividualBuildData()
          location.reload()

          console.log(response.data)
        })
        .catch(error => {
          console.log(error)
        })

      self.$vs.loading.close()
    },
    rejectedIds (ids) {
      let self = this
      self.combined_matches = self.combined_matches.filter(function (ele) {
        return ele.slave_id != ids[0].slave_id
      })
    },
    goBack: function () {
       this.$router.push(
        '/data_build/accounts_data_administration_campaigns'
      )
    },
    proceedToNextStep () {
      let self = this
      this.$vs.loading.close()

      self.$router.push(
        '/accounts/enrichAccountDataToMasterDb/' + self.$route.params.campaignId
      )
    },
    acceptSelected () {
      let self = this

      self.writeSelectedAccountToMasterDB()
    },
    updateMasterdbFlag () {
      let self = this

      self.$vs.notify({
        color: 'primary',
        title: 'Update Master DB',
        text: 'Please wait while the master db is being updated with matched excel accounts.This may take a few minutes'
      })

      self.$vs.loading()

      let data = {}
      data.campaignId = self.$route.params.campaignId
      axios
        .post(self.$base_url + '/api/accounts/update_master_db_flag', data)
        .then(response => {
          if (response.data.status == 'success') {
            // console.log("Master DB Flag Updated Successfully");
            self.$vs.loading.close()

            self.$router.push(
              '/accounts/enrichAccountDataToMasterDb/' +
                self.$route.params.campaignId
            )
          } else {
            self.$vs.notify({
              color: 'danger',
              title: 'Error',
              text: 'Something went wrong. Please try again'
            })
          }
        })
        .catch(error => {
          console.log(error)
        })

      self.$vs.loading.close()
    },
    writeSelectedAccountToMasterDB () {
      let self = this
      this.PLeasewait =
        'Please wait while the data is being written to the master database.This may take a few minutes'
      this.selected = this.removeDuplicates(this.selected, 'id')

      let selected_data = {}
      selected_data.selected_accounts = this.selected
      selected_data.campaignId = this.$route.params.campaignId

      axios
        .post(
          this.$base_url +
            '/api/matched_accounts/write_selected_account_to_masterdb',
          selected_data,
          {
            onDownloadProgress: function (progressEvent) {
              let progress = parseInt(
                Math.round((progressEvent.loaded / progressEvent.total) * 100)
              )

              if (progress == 100) {
                this.uploadPercentage = 100
              }
            }.bind(this),
            onUploadProgress: function (progressEvent) {
              let progress = parseInt(
                Math.round((progressEvent.loaded / progressEvent.total) * 100)
              )

              if (progress == 100) {
                this.uploadPercentage = 50
              }
            }.bind(this)
          }
        )
        .then(response => {
          let no_of_issues = response.data.data.no_of_issues
          let no_of_added_account = response.data.data.no_of_added_account

          if (response.data.status == 'success') {
            self.$vs.loading.close()

            if (no_of_issues == 0) {
              self.updateMasterdbFlag()
            } else {
              this.$vs.dialog({
                color: 'primary',
                title: `Import Account To Campaign`,
                text:
                  no_of_added_account +
                  ' accounts were successfully added to the campaign.  However, ' +
                  no_of_issues +
                  ' selected accounts have issues.  Please resolve these before proceeding.',
                accept: this.finished
              })
            }
          }

          // self.unmatchedIndividualBuildData()
        })
        .catch(error => {
          console.log(error)
        })
    },
    finished () {
      this.selected = []
      this.allSelected = false
      location.reload()

      // this.unmatchedIndividualBuildData()
    },
    // checkDuplicateExists() {
    //   let self = this;
    //   self.paginate.campaignId = self.campaignId;
    //   axios
    //     .post(
    //       this.$base_url + "/api/accounts/deduplicate_csv_accounts_data",
    //       self.paginate
    //     )
    //     .then(response => {
    //       let result = JSON.parse(response.data);

    //       if (result.length == 0) {

    //         self.$router
    //           .push(
    //             "/accounts/optionsAfterImportAccountToCampaign/" +
    //             self.campaignId
    //           )
    //           .catch(() => { });
    //           this.$vs.loading.close();

    //       } else {
    //         this.deduplicateOldNewCSV();
    //       }
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },
    updateOtherFieldDataToMasterDb () {
      let self = this

      self.$vs.dialog({
        color: 'primary',
        title: `Import None Core Fields`,
        text: 'You are about to import non-core fields to the database.  After you click accept this process will start.  You will receive an email once this process has completed. ',
        accept: this.acceptAlert
      })
    },
    acceptAlert () {
      let self = this
      let data = {}
      data.campaign_id = this.campaignId
      axios
        .post(
          this.$base_url +
            '/api/accounts/update_other_field_to_masterdb_from_csv_table',
          data
        )
        .then(response => {
          if (response.data.status == 'success') {
            self.sendCompletedEmail()

            console.log('Updated other field data to master db')
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    sendCompletedEmail () {
      let self = this
      let data = {}
      data.user_id = self.user_id
      data.message = 'Import None Core Fields has been completed.'
      data.subject = 'Import None Core Fields'
      axios
        .post(self.$base_url + '/api/accounts/send_completed_email', data)
        .then(response => {
          if (response.data.status == 'success') {
            self.$vs.notify({
              color: 'success',
              title: 'Import None Core Fields',
              text: 'The email has been sent'
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    deduplicateOldNewCSV () {
      let data = {}
      data.campaignId = this.campaignId
      axios
        .post(
          this.$base_url + '/api/accounts/deduplicate_old_new_csv_account_data',
          data
        )
        .then(response => {
          if (response.data.status == 'success') {
            this.$router.replace(
              '/accounts/deduplicateOldAndNewAccountCSVData/' + this.campaignId
            )
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    ucFirstAllWords (str) {
      var pieces = str.split(' ')
      for (var i = 0; i < pieces.length; i++) {
        var j = pieces[i].charAt(0).toUpperCase()
        pieces[i] = j + pieces[i].substr(1)
      }
      return pieces.join(' ')
    },
    formatUploadedHeader (s) {
      if (typeof s !== 'string') return ''
      if (s.startsWith('ml_')) return ''
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("slave", " ");
      // s = s.replace("ml", " ");
      return s
    },
    unmatchedIndividualBuildData () {
      let self = this
      this.$vs.loading()
      let data = {}
      data.campaignId = this.campaignId
      data.user_id = this.user_id
      axios
        .post(
          this.$base_url +
            '/api/accounts/get_unmatched_individual_build_accounts',
          data
        )
        .then(response => {
          let response_data = JSON.parse(response.data)

          self.unmatch_accounts = response_data.rows.slice(
            (self.currentx - 1) * self.limit,
            self.currentx * self.limit
          )

          self.all_unmatched_accounts = response_data.rows

          self.all_unmatched_accounts = self.all_unmatched_accounts.map(el => {
            if ('Phone' in el && el.Phone !== null && el.Phone !== '') {
              el.Phone_no = el.Phone
            }

            let resultobj = {}
            Object.entries(el).map(([key, val]) => {
              resultobj[
                key.split(' ').join('_').replace(/\W+/g, '').toLowerCase()
              ] = val
              return resultobj
            })
            return resultobj
          })

          self.writeMasterDatabaseAndMatch(self.all_unmatched_accounts[0])

          let total = response_data.total_pages
          self.all_total = total

          self.field_array_columns = response_data.campaign_table_data

          // this.table = response_data.campaign_table_data[0]['table_name'];
          self.$vs.loading.close()
        })
        .catch(error => {
          console.log(error)
        })
    },

    getSicCodes (inputValue) {
      return this.$store
        .dispatch('accountsManagement/getSicCodes', inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.sic_codes
          // console.log(data);
          let mappedArray = []
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].code + ' - ' + data[property].description
            })
          }
          return mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    editHeadOfficeCountry () {
      this.showHeadOfficeCountryField = false
      this.showEditAutocomplete = true
      // console.log(this.$refs.EditAutoComplete.$refs.suggestComponent);
      this.$refs.EditAutoComplete.$refs.suggestComponent.isInFocus = true
      this.$refs.EditAutoComplete.$refs.suggestComponent.isClicking = true
      this.$refs.EditAutoComplete.$refs.suggestComponent.input.value =
        this.accountDescription.head_office_country
      this.$refs.EditAutoComplete.$refs.suggestComponent.value =
        this.accountDescription.head_office_country
    },
    showGroupCompanies () {
      const parentId = this.accountDescription.parent
      this.$store
        .dispatch('accountsManagement/getGroupCompanies', parentId)
        .then(res => {
          this.groupCompanies = res.data
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.groupCompanies = true
            return
          }
          console.error(err)
        })
    },
    getCurrencyCodes (inputValue) {
      return this.$store
        .dispatch('accountsManagement/getCurrencyCodes')
        .then(response => {
          let response_data = response.data
          let mappedArray = []
          for (const property in response_data) {
            mappedArray.push({
              id: response_data[property].id,
              label:
                response_data[property].symbol +
                ' ' +
                response_data[property].name +
                ' ' +
                response_data[property].code
            })
          }
          this.currencyCodes = mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    showParentNameByValue (parentId) {
      this.$store
        .dispatch('accountsManagement/getParentByValue', parentId)
        .then(res => {
          if (res.data.length != 0) {
            this.$refs.EditAccountParentRef.$refs.suggestComponent.input.value =
              res.data.company_name
            this.$refs.EditAccountParentRef.$refs.suggestComponent.value =
              res.data.company_name
          } else {
            this.$refs.EditAccountParentRef.$refs.suggestComponent.input.value =
              this.accountDescription.parent
            this.$refs.EditAccountParentRef.$refs.suggestComponent.value =
              this.accountDescription.parent
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.parent_name = true
            return
          }
          console.error(err)
        })
    },
    showSICCodeByValue (sicValue) {
      let self = this
      this.$store
        .dispatch('accountsManagement/getSICCodeByValue', sicValue)
        .then(res => {
          if (res.data.length != 0) {
            self.accounts.joinedSicAndDescription = []

            self.accounts.joinedSicAndDescription.push({
              id: res.data.id,
              name: res.data.code + ' - ' + res.data.description
            })
          } else {
            self.accounts.joinedSicAndDescription = []
            self.$refs.SicCodeRefEdit.$refs.suggestComponent.input.value =
              self.accountDescription.sic_code
            self.$refs.SicCodeRefEdit.$refs.suggestComponent.value =
              self.accountDescription.sic_code
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    satelliteOfficeShowParentName (parentId) {
      this.$store
        .dispatch('accountsManagement/getParent', parentId)
        .then(res => {
          this.$refs.SatelliteOfficeEditAccountParentRef.$refs.suggestComponent.input.value =
            res.data.company_name
          this.$refs.SatelliteOfficeEditAccountParentRef.$refs.suggestComponent.value =
            res.data.company_name
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.parent_name = true
            return
          }
          console.error(err)
        })
    },
        subsidiaryShowParentName (parentId) {
      this.$store
        .dispatch('accountsManagement/getParent', parentId)
        .then(res => {
          this.$refs.subsidiaryEditAccountParentRef.$refs.suggestComponent.input.value =
            res.data.company_name
          this.$refs.subsidiaryEditAccountParentRef.$refs.suggestComponent.value =
            res.data.company_name
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.parent_name = true
            return
          }
          console.error(err)
        })
    },
    showRegistrationJurisdictionByvalue (country_value) {
      this.$store
        .dispatch('accountsManagement/getCountryByValue', country_value)
        .then(res => {
          if (res.data.length != 0) {
            this.$refs.EditAccountRegistrationJurisdictionRef.$refs.suggestComponent.input.value =
              res.data.name_1
            this.$refs.EditAccountRegistrationJurisdictionRef.$refs.suggestComponent.value =
              res.data.name_1
          } else {
            this.$refs.EditAccountRegistrationJurisdictionRef.$refs.suggestComponent.input.value =
              this.accountDescription.company_jurisdiction
            this.$refs.EditAccountRegistrationJurisdictionRef.$refs.suggestComponent.value =
              this.accountDescription.company_jurisdiction
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.accountDescription.parent = true
            return
          }
          console.error(err)
        })
    },
    satelliteOfficeShowRegistrationJurisdiction (countryId) {
      this.$store
        .dispatch('accountsManagement/getCountry', countryId)
        .then(res => {
          this.$refs.SatelliteOfficeEditAccountRegistrationJurisdictionRef.$refs.suggestComponent.input.value =
            res.data.name_1
          this.$refs.SatelliteOfficeEditAccountRegistrationJurisdictionRef.$refs.suggestComponent.value =
            res.data.name_1
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.accountDescription.parent = true
            return
          }
          console.error(err)
        })
    },
    subsidiaryShowRegistrationJurisdiction (countryId) {
      this.$store
        .dispatch('accountsManagement/getCountry', countryId)
        .then(res => {
          this.$refs.subsidiaryEditAccountRegistrationJurisdictionRef.$refs.suggestComponent.input.value =
            res.data.name_1
          this.$refs.subsidiaryEditAccountRegistrationJurisdictionRef.$refs.suggestComponent.value =
            res.data.name_1
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.accountDescription.parent = true
            return
          }
          console.error(err)
        })
    },
    showVerticalByValue (vertical_value) {
      this.$store
        .dispatch('accountsManagement/getVerticalByValue', vertical_value)
        .then(res => {
          if (res.data.length != 0) {
            this.$refs.EditAccountVerticalRef.$refs.suggestComponent.input.value =
              res.data.vertical
            this.$refs.EditAccountVerticalRef.$refs.suggestComponent.value =
              res.data.vertical
          } else {
            this.$refs.EditAccountVerticalRef.$refs.suggestComponent.input.value =
              this.accountDescription.vertical
            this.$refs.EditAccountVerticalRef.$refs.suggestComponent.value =
              this.accountDescription.vertical
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    satelliteOfficeShowVertical (verticalId) {
      this.$store
        .dispatch('accountsManagement/getVertical', verticalId)
        .then(res => {
          // this.verticalName = res.data.vertical;
          this.$refs.SatelliteOfficeEditAccountVerticalRef.$refs.suggestComponent.input.value =
            res.data.vertical
          this.$refs.SatelliteOfficeEditAccountVerticalRef.$refs.suggestComponent.value =
            res.data.vertical
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    subsidiaryShowVertical (verticalId) {
      this.$store
        .dispatch('accountsManagement/getVertical', verticalId)
        .then(res => {
          // this.verticalName = res.data.vertical;
          this.$refs.subsidiaryEditAccountVerticalRef.$refs.suggestComponent.input.value =
            res.data.vertical
          this.$refs.subsidiaryEditAccountVerticalRef.$refs.suggestComponent.value =
            res.data.vertical
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    removeSelectedSiteAddress (site) {
      this.accounts.satellite_office = this.accounts.satellite_office.filter(
        item => {
          return item.counter != site.counter
        }
      )
    },
    SatelliteOfficeremoveSelectedSiteAddress (site) {
      this.updateSatelliteOfficeAccountDescription.satellite_office =
        this.updateSatelliteOfficeAccountDescription.satellite_office.filter(
          item => {
            return item.counter != site.counter
          }
        )
    },
    addSiteOffice () {
      this.accounts.satellite_office.push({
        counter: ++this.accounts.main_counter,
        address_1: null,
        address_2: null,
        address_3: null,
        city: null,
        county: null,
        postcode: null,
        country: null,
        phone: null,
        phone_code: null
      })

      // console.log(this.accounts.satellite);
    },
    SatelliteOfficeaddSiteOffice () {
      this.updateSatelliteOfficeAccountDescription.satellite_office.push({
        counter: ++this.SatelliteOfficeaccounts.main_counter,
        address_1: null,
        address_2: null,
        address_3: null,
        city: null,
        county: null,
        postcode: null,
        country: null,
        phone: null,
        phone_code: null
      })
      // console.log(this.accounts.main_counter);
      // console.log(this.accounts.satellite);
    },
       subsidiaryaddSiteOffice () {
      this.subsidiaryAccountDescription.satellite_office.push({
        counter: ++this.subsidiaryaccounts.main_counter,
        address_1: null,
        address_2: null,
        address_3: null,
        city: null,
        county: null,
        postcode: null,
        country: null,
        phone: null,
        phone_code: null
      })
      // console.log(this.accounts.main_counter);
      // console.log(this.accounts.satellite);
    },
    removeSelectedWeb (url) {

     

      this.accountDescription.web = this.accountDescription.web.filter(item => {
          return item != url
        })

         this.addWebsite()
        
    },
      removeSatelliteOfficeSelectedWeb (url) {
      this.updateSatelliteOfficeAccountDescription.web = this.SatelliteOfficeaccounts.web =
        this.updateSatelliteOfficeAccountDescription.web.filter(item => {
          return item != url
        })

     

    },
    removeSelectedLinkedin (url) {
      this.accountDescription.linkedin =
        this.accountDescription.linkedin.filter(item => {
          return item != url
        })

      this.addLinkedin()

    },
     removeSatelliteOfficeSelectedLinkedin (url) {
      this.updateSatelliteOfficeAccountDescription.linkedin =
        this.updateSatelliteOfficeAccountDescription.linkedin.filter(item => {
          return item != url
        })

    
    },
    removesubsidiarySelectedWeb (url) {
     

      this.subsidiaryAccountDescription.web = this.subsidiaryAccountDescription.web.filter(item => {
          return item != url
        })
    },
    removesubsidiarySelectedLinkedin (url) {
      this.subsidiaryAccountDescription.linkedin =
        this.subsidiaryAccountDescription.linkedin.filter(item => {
          return item != url
        })
    },
    removeSelectedPhone (phone) {
      this.accountDescription.phone = this.accountDescription.phone.filter(
        item => {
          return item != phone
        }
      )


            this.addWebsite()

    },
    removeSatelliteOfficeSelectedPhone (phone) {
      this.updateSatelliteOfficeAccountDescription.phone =
        this.updateSatelliteOfficeAccountDescription.phone.filter(item => {
          return item != phone
        })

                this.SatelliteOfficeaddWebsite()

    },
      removesubsidiarySelectedPhone (phone) {
      this.subsidiaryAccountDescription.phone =
        this.subsidiaryAccountDescription.phone.filter(item => {
          return item != phone
        })

                this.subsidiaryaddWebsite()

    },
    removeSelectedSicCode (sic_code) {
      this.accountDescription.sic_code =
        this.accountDescription.sic_code.filter(item => {
          return item != sic_code
        })
    },
    removeNewSelectedSicCode (selected) {
      this.accounts.joinedSicAndDescription =
        this.accounts.joinedSicAndDescription.filter(item => {
          return item != selected
        })
    },
    removeSatelliteNewSelectedSicCode (selected) {
      this.SatelliteOfficeaccounts.joinedSicAndDescription =
        this.SatelliteOfficeaccounts.joinedSicAndDescription.filter(item => {
          return item != selected
        })
    },
    removeNewSelectedPhone (selected) {
      this.accounts.joinedPhoneAndTypes =
        this.accounts.joinedPhoneAndTypes.filter(item => {
          return item != selected
        })
    },
    validDomain (userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        )
        if (res == null) {
          return false
        }
      }
      return true
    },

    addPhone () {
      let self = this

      self.accountDescription.phone.push({
        phone_code: null,
        phone_no: null,
        phone_type: null
      })

            self.addWebsite()
      
    },

    addSatelliteOfficePhone () {
      let self = this

      self.updateSatelliteOfficeAccountDescription.phone.push({
        phone_code: null,
        phone_no: null,
        phone_type: null
      })

            self.SatelliteOfficeaddWebsite()

    },
       addsubsidiaryPhone () {
      let self = this

      self.subsidiaryAccountDescription.phone.push({
        phone_code: null,
        phone_no: null,
        phone_type: null
      })

            self.subsidiaryaddWebsite()

    },

    SatelliteOfficeaddPhoneNumbers () {
      if (
        this.SatelliteOfficeaccounts.phone_code &&
        this.SatelliteOfficeaccounts.phone &&
        this.SatelliteOfficeaccounts.phoneType &&
        !this.SatelliteOfficeaccounts.joinedPhoneAndTypes.includes(
          this.SatelliteOfficeaccounts.phoneType.name +
            ' : ' +
            this.SatelliteOfficeaccounts.phone_code.phone_code +
            ' - ' +
            this.SatelliteOfficeaccounts.phone
        )
      )
        this.SatelliteOfficeaccounts.joinedPhoneAndTypes.push(
          this.SatelliteOfficeaccounts.phoneType.name +
            ' : ' +
            this.SatelliteOfficeaccounts.phone_code.phone_code +
            ' - ' +
            this.SatelliteOfficeaccounts.phone
        )
      let mappedPhoneTypes = {}
      mappedPhoneTypes.phone_no = this.SatelliteOfficeaccounts.phone
      mappedPhoneTypes.phone_type = this.SatelliteOfficeaccounts.phoneType.slug

      mappedPhoneTypes.phone_code =
        this.SatelliteOfficeaccounts.phone_code.phone_code

      this.SatelliteOfficeaccounts.phoneWithTypes.push(mappedPhoneTypes)

      console.log(this.SatelliteOfficeaccounts.phoneWithTypes)

      this.SatelliteOfficeaccounts.phone = null
      this.SatelliteOfficeaccounts.phone_code = null
      this.SatelliteOfficeaccounts.phoneType = null
    },
  addSicCodes () {


      if(moduleAccountsManagement.sic_codes_selected != undefined && moduleAccountsManagement.sic_codes_selected != null){

        if (!this.accounts.joinedSicAndDescription.includes(
                    moduleAccountsManagement.sic_codes_selected
                  )){
                      this.accounts.joinedSicAndDescription.push(
                    moduleAccountsManagement.sic_codes_selected
                  )

                  }
          
      }

      


      

      // console.log(moduleAccountsManagement.sic_codes_selected)
      // this.accounts.sicWithDescription.push(moduleAccountsManagement.sic_codes_selected);

      this.$refs.SicCodeRefEdit.$refs.suggestComponent.selected = null
      this.$refs.SicCodeRefEdit.$refs.suggestComponent.input.value = null
      this.$refs.SicCodeRefEdit.$refs.suggestComponent.value = null

      this.selected_sic_code = null
    },
    SatelliteOfficeaddSicCodes () {



      if(moduleAccountsManagement.sic_codes_selected != undefined && moduleAccountsManagement.sic_codes_selected != null){
        if (!this.SatelliteOfficeaccounts.joinedSicAndDescription.includes(
                    moduleAccountsManagement.sic_codes_selected
                  )){
                      this.SatelliteOfficeaccounts.joinedSicAndDescription.push(
                    moduleAccountsManagement.sic_codes_selected
                  )

                  }
      }
      // this.SatelliteOfficeaccounts.joinedSicAndDescription.push(
      //   moduleAccountsManagement.sic_codes_selected
      // )

      this.$refs.SatelliteOfficeSicCodeRefEdit.$refs.suggestComponent.selected =
        null
      this.$refs.SatelliteOfficeSicCodeRefEdit.$refs.suggestComponent.input.value =
        null
      this.$refs.SatelliteOfficeSicCodeRefEdit.$refs.suggestComponent.value =
        null

      this.selected_sic_code = null
    },
       subsidiaryaddSicCodes () {


        if(moduleAccountsManagement.sic_codes_selected != undefined && moduleAccountsManagement.sic_codes_selected != null){
          if (!this.subsidiaryaccounts.joinedSicAndDescription.includes(
                      moduleAccountsManagement.sic_codes_selected
                    )){
                        this.subsidiaryaccounts.joinedSicAndDescription.push(
                      moduleAccountsManagement.sic_codes_selected
                    )
    
                    }
        }


      // this.subsidiaryaccounts.joinedSicAndDescription.push(
      //   moduleAccountsManagement.sic_codes_selected
      // )

      this.$refs.subsidiarySicCodeRefEdit.$refs.suggestComponent.selected =
        null
      this.$refs.subsidiarySicCodeRefEdit.$refs.suggestComponent.input.value =
        null
      this.$refs.subsidiarySicCodeRefEdit.$refs.suggestComponent.value =
        null

      this.selected_sic_code = null
    },
    addWebsite () {
      if (
        this.accountDescription.web == undefined ||
        this.accountDescription.web == null
      ) {
        this.accountDescription.web = []
      }

      this.getMatchedWebsites(this.accounts.web)
    },
    AddWebsiteAnyWay () {
      if (
        this.accounts.web &&
        !this.accountDescription.web.includes(this.accounts.web)
      )
        this.accountDescription.web.push({ url: this.accounts.web })
      this.accounts.web = null
      this.MatchedWebsitePopupActive = false
    },
    CancelWebsitePopup () {
      this.accounts.web = null
      this.MatchedWebsitePopupActive = false
    },
    addLinkedin () {
      if (
        this.accountDescription.linkedin == undefined ||
        this.accountDescription.linkedin == null
      ) {
        this.accountDescription.linkedin = []
      }
      this.getMatchedLinkedIn(this.accounts.linkedin)
    },
    AddLinkedInAnyWay () {
      if (
        this.accounts.linkedin &&
        !this.accountDescription.linkedin.includes(this.accounts.linkedin)
      )
        this.accountDescription.linkedin.push({ url: this.accounts.linkedin })
      this.accounts.linkedin = null

      this.MatchedLinkedInPopupActive = false
    },
    CancelLinkedInPopup () {
      this.accounts.linkedin = null
      this.MatchedLinkedInPopupActive = false
    },
     subsidiaryaddWebsite () {
      if (
        this.subsidiaryAccountDescription.web == undefined ||
        this.subsidiaryAccountDescription.web == null
      ) {
        this.subsidiaryAccountDescription.web = []
      }

      if (
        this.subsidiaryaccounts.web &&
        !this.subsidiaryAccountDescription.web.includes(
          this.accounts.web
        )
      )
        this.subsidiaryAccountDescription.web.push({
          url: this.subsidiaryaccounts.web
        })
      this.subsidiaryaccounts.web = null
    },
    subsidiaryaddLinkedin () {
      if (
        this.subsidiaryAccountDescription.linkedin == undefined ||
        this.subsidiaryAccountDescription.linkedin == null
      ) {
        this.subsidiaryAccountDescription.linkedin = []
      }
      if (
        this.subsidiaryaccounts.linkedin &&
        !this.subsidiaryAccountDescription.linkedin.includes(
          this.subsidiaryaccounts.linkedin
        )
      )
        this.subsidiaryAccountDescription.linkedin.push({
          url: this.subsidiaryaccounts.linkedin
        })
      this.subsidiaryaccounts.linkedin = null
    },

    SatelliteOfficeaddWebsite () {
      if (
        this.updateSatelliteOfficeAccountDescription.web == undefined ||
        this.updateSatelliteOfficeAccountDescription.web == null
      ) {
        this.updateSatelliteOfficeAccountDescription.web = []
      }

      if (
        this.SatelliteOfficeaccounts.web &&
        !this.updateSatelliteOfficeAccountDescription.web.includes(
          this.accounts.web
        )
      )
        this.updateSatelliteOfficeAccountDescription.web.push({
          url: this.SatelliteOfficeaccounts.web
        })
      this.SatelliteOfficeaccounts.web = null
    },
    SatelliteOfficeaddLinkedin () {
      if (
        this.updateSatelliteOfficeAccountDescription.linkedin == undefined ||
        this.updateSatelliteOfficeAccountDescription.linkedin == null
      ) {
        this.updateSatelliteOfficeAccountDescription.linkedin = []
      }
      if (
        this.SatelliteOfficeaccounts.linkedin &&
        !this.updateSatelliteOfficeAccountDescription.linkedin.includes(
          this.SatelliteOfficeaccounts.linkedin
        )
      )
        this.updateSatelliteOfficeAccountDescription.linkedin.push({
          url: this.SatelliteOfficeaccounts.linkedin
        })
      this.SatelliteOfficeaccounts.linkedin = null
    },
    updateSatelliteOfficeForm () {
      this.$vs.loading()

      this.updateSatelliteOfficeAccountDescription.registered_office_country =
        this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value
      this.updateSatelliteOfficeAccountDescription.registered_office_country =
        this.$refs.SatelliteOfficeaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value

      this.updateSatelliteOfficeAccountDescription.head_office_country =
        this.$refs.SatelliteOfficeaccountEditHeadOfficeCountryRef.$refs.suggestComponent.value
      this.updateSatelliteOfficeAccountDescription.head_office_country =
        this.$refs.SatelliteOfficeaccountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value

      if (this.updateSatelliteOfficeAccountDescription.is_sole_trader) {
        this.updateSatelliteOfficeAccountDescription.IsSoleTraderFields = {
          company_name:
            this.updateSatelliteOfficeAccountDescription.company_name,
          head_office_country:
            this.updateSatelliteOfficeAccountDescription.head_office_country
        }

        if (
          this.updateSatelliteOfficeAccountDescription.head_office_country ==
            null ||
          this.updateSatelliteOfficeAccountDescription.head_office_country == ''
        ) {
          this.head_office_country_validation =
            'The Head Office Country field is required'
          this.registered_office_country_validation = null
          return false
        } else {
          this.head_office_country_validation = null
        }
      } else {
        this.updateSatelliteOfficeAccountDescription.IsSoleTraderFields = {
          company_registration_number:
            this.updateSatelliteOfficeAccountDescription
              .company_registration_number,
          registered_office_country:
            this.updateSatelliteOfficeAccountDescription
              .registered_office_country
        }

        if (
          this.updateSatelliteOfficeAccountDescription
            .registered_office_country == null ||
          this.updateSatelliteOfficeAccountDescription
            .registered_office_country == ''
        ) {
          this.registered_office_country_validation =
            'The Registered Office Country field is required'
          this.head_office_country_validation = null
          return false
        } else {
          this.registered_office_country_validation = null
        }
      }
      if (moduleAccountsManagement.autocomplete_selected) {
        this.updateSatelliteOfficeAccountDescription.parent =
          moduleAccountsManagement.autocomplete_selected.id
      }
      if (moduleAccountsManagement.vertical_selected) {
        this.updateSatelliteOfficeAccountDescription.vertical =
          moduleAccountsManagement.vertical_selected.id
      }
      if (moduleAccountsManagement.countries_selected) {
        this.updateSatelliteOfficeAccountDescription.registration_jurisdiction =
          moduleAccountsManagement.countries_selected.id
      }

      this.updateSatelliteOfficeAccountDescription.phoneWithTypes = []

      console.log(
        'this.updateSatelliteOfficeAccountDescription.phone',
        this.updateSatelliteOfficeAccountDescription.phone
      )

      // this.updateSatelliteOfficeAccountDescription.phone.map(phone_ele => {
      //   phone_ele.phone_type.map(phone_type_ele => {
      //     if (phone_type_ele.phone_id == phone_ele.id) {
      //       let mappedPhoneTypes = {}
      //       mappedPhoneTypes.phone_code = phone_ele.phone_code
      //       mappedPhoneTypes.phone_no = phone_ele.phone_no
      //       mappedPhoneTypes.phone_type = phone_type_ele.type
      //       this.updateSatelliteOfficeAccountDescription.phoneWithTypes.push(
      //         mappedPhoneTypes
      //       )
      //     }
      //   })
      // })
      // this.updateSatelliteOfficeAccountDescription.phoneWithTypes = _.unionBy(
      //   this.updateSatelliteOfficeAccountDescription.phoneWithTypes,
      //   this.SatelliteOfficeaccounts.phoneWithTypes,
      //   'phone_no'
      // )

      this.updateSatelliteOfficeAccountDescription.joinedSicAndDescription =
        this.SatelliteOfficeaccounts.joinedSicAndDescription

      if (
        this.updateSatelliteOfficeAccountDescription.revenue != null &&
        this.updateSatelliteOfficeAccountDescription.currency_code == null
      ) {
        this.satellite_office_currency_code_validation =
          'The currency code field is required'
        return false
      }

      this.updateSatelliteOfficeAccountDescription.user_id = this.user_id

      this.updateSatelliteOfficeAccountDescription.campaign_id =
        this.$route.params.campaignId

      this.updateSatelliteOfficeAccountDescription.table_id = this.temp_table_id

      this.updateSatelliteOfficeAccountAndAddToCampaign()

      this.$vs.loading.close()
    },
    updateSatelliteOfficeAccountAndAddToCampaign () {
      let self = this
      self.$store
        .dispatch(
          'accountsManagement/updateSatelliteOfficeAccountAndAddToCampaign',
          self.updateSatelliteOfficeAccountDescription
        )
        .then(res => {
          if (res.data.status == 'fail') {
            self.getPotentialMatchesForDataBuild()
          } else {
            

            let result_data = res.data.data
            self.accountDescription.account_id = result_data.id
            self.accountDescription.campaign_id = self.$route.params.campaignId

            self.AddMatchedNoneCoreFields()

      self.showUpdateSatelliteOfficePopup = false

      self.MatchedWebsitePopupActive = false

      self.MatchedLinkedInPopupActive = false

      self.MatchedAccountsPopupActive = false

      self.updateSatelliteOfficePopupActive = false

      self.subsidiaryPopupActive = false


       const myElement = document.getElementById('satelliteOfficePopup')

      // Check if the element exists before attempting to modify its style
      if (myElement) {
        // Set the display property to 'none' to hide the element
        myElement.style.display = 'none'
      }


      console.log('self.accountDescription.id', self.accountDescription)
      


            


            self.matchedData()

            

            

          }
        })
        .catch(err => {
          console.log(err)

          if (err.response.status === 401) {
            self.$router.replace('/login')
          }
        })
    },
    matchedData() {
    let self = this;
      this.$vs.loading()

      this.paginate.campaignId = self.$route.params.campaignId


      if (self.accountDescription.id == undefined || self.accountDescription.id == null) {

        self.paginate.buildId = self.updateSatelliteOfficeAccountDescription.table_id
      }else{
        self.paginate.buildId = self.accountDescription.id
      }

      axios
        .post(
          this.$base_url + "/api/accounts/enrich_data_build_account_data_to_masterdatabase",
          this.paginate
        )
        .then(response => {

          console.log("RESS" , JSON.parse(response.data));


          let match_accounts = JSON.parse(response.data).rows;

          if (match_accounts.length > 0) {


        self.$router.push(
              '/accounts/enrichDataBuildAccountDataToMasterDbFromList/' +
                self.$route.params.campaignId + '/' +
                self.paginate.buildId
            )


          }else{


            
             self.$router.push(
        '/data_build/build_accounts_list/' + this.$route.params.campaignId
      )
          }


         





        
        })
        .catch(error => {
          console.log(error);
        });
    },
    AddMatchedNoneCoreFields () {
      this.$store
        .dispatch(
          'accountsManagement/AddMatchedNoneCoreFields',
          this.accountDescription
        )
        .then(res => {
          if (res.data.status == 'success') {
           console.log('Matched None Core Fields Added Successfully')
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    submitSubsidiaryForm () {
      this.$vs.loading()


      this.subsidiaryAccountDescription.registered_office_country =
        this.$refs.subsidiaryaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value
      this.subsidiaryAccountDescription.registered_office_country =
        this.$refs.subsidiaryaccountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value

      this.subsidiaryAccountDescription.head_office_country =
        this.$refs.subsidiaryaccountEditHeadOfficeCountryRef.$refs.suggestComponent.value
      this.subsidiaryAccountDescription.head_office_country =
        this.$refs.subsidiaryaccountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value

      if (this.subsidiaryAccountDescription.is_sole_trader) {
        this.subsidiaryAccountDescription.IsSoleTraderFields = {
          company_name:
            this.subsidiaryAccountDescription.company_name,
          head_office_country:
            this.subsidiaryAccountDescription.head_office_country
        }

        if (
          this.subsidiaryAccountDescription.head_office_country ==
            null ||
          this.subsidiaryAccountDescription.head_office_country == ''
        ) {
          this.head_office_country_validation =
            'The Head Office Country field is required'
          this.registered_office_country_validation = null
          return false
        } else {
          this.head_office_country_validation = null
        }
      } else {
        this.subsidiaryAccountDescription.IsSoleTraderFields = {
          company_registration_number:
            this.subsidiaryAccountDescription
              .company_registration_number,
          registered_office_country:
            this.subsidiaryAccountDescription
              .registered_office_country
        }

        if (
          this.subsidiaryAccountDescription
            .registered_office_country == null ||
          this.subsidiaryAccountDescription
            .registered_office_country == ''
        ) {
          this.registered_office_country_validation =
            'The Registered Office Country field is required'
          this.head_office_country_validation = null
          return false
        } else {
          this.registered_office_country_validation = null
        }
      }
      if (moduleAccountsManagement.autocomplete_selected) {
        this.subsidiaryAccountDescription.parent =
          moduleAccountsManagement.autocomplete_selected.id
      }
      if (moduleAccountsManagement.vertical_selected) {
        this.subsidiaryAccountDescription.vertical =
          moduleAccountsManagement.vertical_selected.id
      }
      if (moduleAccountsManagement.countries_selected) {
        this.subsidiaryAccountDescription.registration_jurisdiction =
          moduleAccountsManagement.countries_selected.id
      }

      this.subsidiaryAccountDescription.phoneWithTypes = []

      this.subsidiaryAccountDescription.phone.map(phone_ele => {
        if (
          typeof phone_ele.phone_code === 'object' &&
          phone_ele.phone_code !== null &&
          !Array.isArray(phone_ele.phone_code)
        ) {
          phone_ele.phone_code = phone_ele.phone_code.phone_code
        } else {
          phone_ele.phone_code = phone_ele.phone_code
        }

        if (
          typeof phone_ele.phone_type === 'object' &&
          phone_ele.phone_type !== null &&
          !Array.isArray(phone_ele.phone_type)
        ) {
          phone_ele.phone_type = phone_ele.phone_type.name
        } else {
          phone_ele.phone_type = phone_ele.phone_type
        }

        let mappedPhoneTypes = {}
        mappedPhoneTypes.phone_code = phone_ele.phone_code
        mappedPhoneTypes.phone_no = phone_ele.phone_no
        mappedPhoneTypes.phone_type = phone_ele.phone_type
        this.subsidiaryAccountDescription.phoneWithTypes.push(
          mappedPhoneTypes
        )
      })

      this.subsidiaryAccountDescription.phoneWithTypes = _.unionBy(
        this.subsidiaryAccountDescription.phoneWithTypes,
        this.subsidiaryaccounts.phoneWithTypes,
        'phone_no'
      )

      this.subsidiaryAccountDescription.joinedSicAndDescription =
        this.subsidiaryaccounts.joinedSicAndDescription

      if (
        this.subsidiaryAccountDescription.revenue != null &&
        this.subsidiaryAccountDescription.currency_code == null
      ) {
        this.satellite_office_currency_code_validation =
          'The currency code field is required'
        return false
      }

      this.subsidiaryAccountDescription.user_id = this.user_id

      this.subsidiaryAccountDescription.campaign_id =
        this.$route.params.campaignId

      this.subsidiaryAccountDescription.table_id = this.temp_table_id

      this.submitSubsidiaryAccountAndAddToCampaign()
    },
    submitSubsidiaryAccountAndAddToCampaign () {
      let self = this
      this.$store
        .dispatch(
          'accountsManagement/submitSubsidiaryAccountAndAddToCampaign',
          this.subsidiaryAccountDescription
        )
        .then(res => {
          if (res.data.status == 'fail') {
            console.log('Failed to add subsidiary account')
            console.log(res)
          } else {
            console.log('Subsidiary Account Added Successfully')

            self.showUpdatesubsidiaryPopup = false

            self.MatchedWebsitePopupActive = false

            self.MatchedLinkedInPopupActive = false

            self.MatchedAccountsPopupActive = false

            self.updatesubsidiaryPopupActive = false

            self.subsidiaryPopupActive = false

            // Get a reference to the element with the ID "myElement"
            const myElement = document.getElementById('subsidiaryPopup')

            // Check if the element exists before attempting to modify its style
            if (myElement) {
              // Set the display property to 'none' to hide the element
              myElement.style.display = 'none'
            }
          }

          self.$vs.loading.close()
        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    submitForm () {
      this.$vs.loading()

      this.correction_fields_array = []

      this.currency_code_validation = null

      this.accountDescription.registered_office_country =
        this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value
      this.accountDescription.registered_office_country =
        this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value

      this.accountDescription.head_office_country =
        this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value
      this.accountDescription.head_office_country =
        this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value

      this.accountDescription.account_user_id = this.user_id
      this.accountDescription.campaign_id = this.$route.params.campaignId
      this.accountDescription.table_id = this.temp_table_id
      this.accountDescription.id = this.temp_table_id
      this.accountDescription.no_of_employees =
        this.accountDescription.employees

      if (this.accountDescription.no_of_employees == '') {
        this.accountDescription.no_of_employees = null
      }

      if (this.accountDescription.revenue == '') {
        this.accountDescription.revenue = null
      }

      console.log(
        'this.accounts.joinedSicAndDescription',
        this.accounts.joinedSicAndDescription
      )

      this.accountDescription.joinedSicAndDescription =
        this.accounts.joinedSicAndDescription

      this.accountDescription.satellite_office = this.accounts.satellite_office

      this.$validator.validateAll().then(result => {
        if (result) {
          if (moduleAccountsManagement.autocomplete_selected) {
            this.accountDescription.parent =
              moduleAccountsManagement.autocomplete_selected.id
          }
          if (moduleAccountsManagement.vertical_selected) {
            this.accountDescription.vertical =
              moduleAccountsManagement.vertical_selected.id
          }
          if (moduleAccountsManagement.countries_selected) {
            this.accountDescription.registration_jurisdiction =
              moduleAccountsManagement.countries_selected.id
          } else {
            this.accountDescription.registration_jurisdiction =
              this.accountDescription.company_jurisdiction
          }

          if (moduleAccountsManagement.head_office_country_selected) {
            this.accountDescription.head_office_country =
              moduleAccountsManagement.head_office_country_selected.name
          }

          if (moduleAccountsManagement.registered_office_country_selected) {
            this.accountDescription.registered_office_country =
              moduleAccountsManagement.registered_office_country_selected.name
          }

          if (this.accountDescription.revenue == '') {
            this.accountDescription.revenue = null
          }

          if (
            this.accountDescription.revenue != null &&
            this.accountDescription.currency_code == null
          ) {
            this.currency_code_validation =
              'The currency code field is required'
            this.$vs.loading.close()

            return false
          }

          this.addAccounts()
          // if form have no errors
        } else {
          this.$vs.loading.close()

          // form have errors
        }

        this.$vs.loading.close()
      })
    },
    addAccounts () {
      let self = this

      this.$store
        .dispatch(
          'accountsManagement/buildAccountAndAddToCampaign',
          this.accountDescription
        )
        .then(res => {
          if (res.data.status == 'required_correction') {
            this.$vs.dialog({
              color: 'primary',
              title: `Required Correction`,
              text: 'The fields with red title should be corrected. Please update it and submit again'
            })

            self.correction_fields_array = res.data.correction_fields
          } else if (res.data.status == 'company_registration_number_exists') {
            self.submit_match_accounts = res.data.data
            self.MatchedAccountsPopupActive = true
          } else if (
            res.data.status ==
            'company_name_and_registered_office_country_exists'
          ) {
            self.submit_match_accounts = res.data.data
            self.MatchedAccountsPopupActive = true

            console.log(
              'Company Name and Registered Office Country Exists',
              res.data.data
            )
          } else {
            this.$vs.notify({
              color: 'success',
              title: 'Account Added',
              text: 'The account was added successfully'
            })

              this.$router.push(
        '/data_build/build_accounts_list/' + this.$route.params.campaignId
      )
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getPotentialMatchesForDataBuild () {


      let self = this
      self.potential_account_matches = []
      let data = {}
      data.company_name = this.accountDescription.company_name
      data.registered_office_country =
        this.accountDescription.registered_office_country
      data.company_registration_number =
        this.accountDescription.company_registration_number
      data.website = this.accountDescription.website
      data.linkedin = this.accountDescription.linkendin

      this.$store
        .dispatch('accountsManagement/getPotentialMatchesForDataBuild', data)
        .then(res => {
          self.potential_account_matches = res.data
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getMatchedWebsites (web) {
      let self = this

      if (web != null && web != '') {
        web = web.trim()
      }

      self.matched_websites = []
      let data = {}
      data.website = web

      this.$store
        .dispatch('accountsManagement/getMatchedWebsites', data)
        .then(res => {
          if (res.data.length != 0) {
            self.matched_websites = res.data
            self.MatchedWebsitePopupActive = true
          } else {
            self.AddWebsiteAnyWay()
          }

          console.log('MATCHED WEBSITES', self.matched_websites)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getMatchedLinkedIn (linkedin) {
      let self = this
      self.matched_linkedins = []
      let data = {}

      if (linkedin != null && linkedin != '') {
        linkedin = linkedin.trim()
      }

      data.linkedin = linkedin

      this.$store
        .dispatch('accountsManagement/getMatchedLinkedIn', data)
        .then(res => {
          if (res.data.length != 0) {
            self.matched_linkedins = res.data
            self.MatchedLinkedInPopupActive = true
          } else {
            self.AddLinkedInAnyWay()
          }
          console.log('MATCHED LINKEDIN', self.matched_linkedins)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getSubsidiaryAccounts () {
      let self = this
      self.submit_match_accounts = []
      let data = {}
      data.parent = this.$refs.EditAccountParentRef.$refs.suggestComponent.value

      if (data.parent == undefined) {
        data.parent =
          self.$refs.EditAccountParentRef.$refs.suggestComponent.input.value
      }

      if (data.parent == '') {
        return
      }

      this.$store
        .dispatch('accountsManagement/getSubsidiaryAccounts', data)
        .then(res => {
          console.log('SUBSIDIARY ACCOUNTS', res.data)

          self.viewSubsidiaryAccountDetails(res.data[0])

          // self.submit_match_accounts = res.data
          // self.MatchedAccountsPopupActive = true
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getCorrectionFields () {
      let self = this
      self.correction_fields_array = []
      let data = {}
      data.registered_office_country =
        this.accountDescription.registered_office_country
      data.head_office_country = this.accountDescription.head_office_country
      data.phone = this.accountDescription.phone
      data.sic_code = this.accountDescription.sic_code
      data.currency_code = this.accountDescription.currency_code
      data.vertical = this.accountDescription.vertical
      data.parent = this.accountDescription.parent
      data.registration_jurisdiction =
        this.accountDescription.company_jurisdiction
      data.revenue = this.accountDescription.revenue
      data.no_of_employees = this.accountDescription.no_of_employees
      data.switchboard_phone_code =
        this.accountDescription.switchboard_phone_code
      data.switchboard = this.accountDescription.switchboard
      data.phone_code = this.accountDescription.phone_code
      data.phone_no = this.accountDescription.phone_no
      data.phone_type = this.accountDescription.phone_type
      data.campaign_id = this.campaignId
      data.table_id = this.temp_table_id

      this.$store
        .dispatch('accountsManagement/getCorrectionFields', data)
        .then(res => {
          self.correction_fields_array = res.data

          console.log('CORRECTION FIELDS', self.correction_fields_array)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getPhoneTypes () {
      this.$store
        .dispatch('accountsManagement/getPhoneTypes')
        .then(res => {
          this.accounts.phoneTypes = res.data
          this.accounts.phoneTypes = this.accounts.phoneTypes.filter(
            item => item.name != 'Site Switchboard'
          )
          this.SatelliteOfficeaccounts.phoneTypes =
            this.SatelliteOfficeaccounts.phoneTypes.filter(
              item => item.name != 'Site Switchboard'
            )
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getVerticals (inputValue) {
      return this.$store
        .dispatch('accountsManagement/getVerticals', inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.verticals
          let mappedArray = []
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].vertical
            })
          }
          return mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getCountries (inputValue) {
      return this.$store
        .dispatch('accountsManagement/getCountries', inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.countries
          // console.log(data);
          let mappedArray = []
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].name_1
            })
          }
          return mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    accept () {
      this.popupActive = false
    },
    reject () {
      // this.popupActive = false;
      // this.$router.push({ path: "/dashboard" });
      this.$router.go(0)
    },
    getParentCompany (inputValue) {
      return this.$store
        .dispatch('accountsManagement/searchAutocomplete', inputValue)
        .then(response => {
          let data = JSON.parse(JSON.parse(JSON.stringify(response.data)))
          let mappedArray = []
          for (const property in data) {
            mappedArray.push({
              id: data[property].uuid,
              name: data[property].company_name
            })
          }
          return mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    }
  },
  created () {
    var self = this
    defineAbilitiesFor().then(function (data) {
      self.abilities = data
    })
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.user_id = userInfo['uid']
    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule('accountsManagement', moduleAccountsManagement)
      moduleAccountsManagement.isRegistered = true
    }
    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        'campaignsManagement',
        moduleCampaignsManagement
      )
      moduleCampaignsManagement.isRegistered = true
    }
    this.campaignId = this.$route.params.campaignId
  }
}
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.searchbox2 {
  padding-left: 40px;
  width: 500px;
  float: right;
  margin-top: 10px;
  margin-bottom: 50px;
}

.satellite_office_field {
  margin-right: 453px;
}

.relative {
  /* position: fixed !important; */
  z-index: 999;
  /* width: 98.5%; */
}

.vxtable {
  /* position: absolute !important; */
  margin-top: 20px;
}

.correction_field_class {
  color: red;
}

.correction_field_input_class {
  border: 1px solid red;
}

.vs-input-class {
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.2);
  font-size: 1rem;
  height: 38px;
  padding-left: 10px;
  padding-right: -10px;
  border-radius: 4px;
  background: transparent;
  transition: all 0.2s ease;
}
</style>
